var items = {
  "block.minecraft.acacia_button": "Beechen Button",
  "block.minecraft.acacia_door": "Beechen Door",
  "block.minecraft.acacia_fence": "Beechen Hedge",
  "block.minecraft.acacia_fence_gate": "Beechen Hedge Gate",
  "block.minecraft.acacia_hanging_sign": "Beechen Hung Wallsign",
  "block.minecraft.acacia_leaves": "Beech Leaves",
  "block.minecraft.acacia_log": "Beechen Log",
  "block.minecraft.acacia_planks": "Beechen Timber",
  "block.minecraft.acacia_pressure_plate": "Beechen Pressure Plate",
  "block.minecraft.acacia_sapling": "Beech Sapling",
  "block.minecraft.acacia_shelf": "Beechen Shelf",
  "block.minecraft.acacia_sign": "Beechen Sign",
  "block.minecraft.acacia_slab": "Beechen Slab",
  "block.minecraft.acacia_stairs": "Beechen Stairs",
  "block.minecraft.acacia_trapdoor": "Beechen Hatch",
  "block.minecraft.acacia_wall_hanging_sign": "Beechen Hung Wallsign",
  "block.minecraft.acacia_wall_sign": "Beechen Hung Sign",
  "block.minecraft.acacia_wood": "Beechen Wood",
  "block.minecraft.activator_rail": "Sparking Iron-Rut",
  "block.minecraft.air": "Air",
  "block.minecraft.allium": "Saffron",
  "block.minecraft.amethyst_block": "Block of Amethyst",
  "block.minecraft.amethyst_cluster": "Amethyst Clust'r",
  "block.minecraft.ancient_debris": "Ancient Scraps",
  "block.minecraft.andesite": "Grainstone",
  "block.minecraft.andesite_slab": "Grainstone Slab",
  "block.minecraft.andesite_stairs": "Grainstone Stairs",
  "block.minecraft.andesite_wall": "Grainstone Hedge",
  "block.minecraft.anvil": "Anvil",
  "block.minecraft.attached_melon_stem": "Attach'd Melon Stem",
  "block.minecraft.attached_pumpkin_stem": "Attach'd Pumpion Stem",
  "block.minecraft.azalea": "Shrub",
  "block.minecraft.azalea_leaves": "Shrub Leaves",
  "block.minecraft.azure_bluet": "Harebell",
  "block.minecraft.bamboo": "Bamboo",
  "block.minecraft.bamboo_block": "Block of Bamboo",
  "block.minecraft.bamboo_button": "Bamboo Button",
  "block.minecraft.bamboo_door": "Bamboo Door",
  "block.minecraft.bamboo_fence": "Bamboo Hedge",
  "block.minecraft.bamboo_fence_gate": "Bamboo Hedge Gate",
  "block.minecraft.bamboo_hanging_sign": "Bamboo Hung Sign",
  "block.minecraft.bamboo_mosaic": "Mosaic'd Bamboo",
  "block.minecraft.bamboo_mosaic_slab": "Mosaic'd Bamboo Slab",
  "block.minecraft.bamboo_mosaic_stairs": "Mosaic'd Bamboo Stairs",
  "block.minecraft.bamboo_planks": "Bamboo Timber",
  "block.minecraft.bamboo_pressure_plate": "Bamboo Pressure Plate",
  "block.minecraft.bamboo_sapling": "Bamboo Shoot",
  "block.minecraft.bamboo_shelf": "Bamboo Shelf",
  "block.minecraft.bamboo_sign": "Bamboo Sign",
  "block.minecraft.bamboo_slab": "Bamboo Slab",
  "block.minecraft.bamboo_stairs": "Bamboo Stairs",
  "block.minecraft.bamboo_trapdoor": "Bamboo Hatch",
  "block.minecraft.bamboo_wall_hanging_sign": "Bamboo Hung Wallsign",
  "block.minecraft.bamboo_wall_sign": "Bamboo Hung Sign",
  "block.minecraft.banner.base.black": "Entirely Black Plain",
  "block.minecraft.banner.base.blue": "Entirely Blue Plain",
  "block.minecraft.banner.base.brown": "Entirely Brown Plain",
  "block.minecraft.banner.base.cyan": "Entirely Cyan Plain",
  "block.minecraft.banner.base.gray": "Entirely Grey Plain",
  "block.minecraft.banner.base.green": "Entirely Green Plain",
  "block.minecraft.banner.base.light_blue": "Entirely Whey Plain",
  "block.minecraft.banner.base.light_gray": "Entirely Pale Grey Plain",
  "block.minecraft.banner.base.lime": "Entirely Lime Plain",
  "block.minecraft.banner.base.magenta": "Entirely Magenta Plain",
  "block.minecraft.banner.base.orange": "Entirely Tawny Plain",
  "block.minecraft.banner.base.pink": "Entirely Pink Plain",
  "block.minecraft.banner.base.purple": "Entirely Purple Plain",
  "block.minecraft.banner.base.red": "Entirely Crimson Plain",
  "block.minecraft.banner.base.white": "Entirely White Plain",
  "block.minecraft.banner.base.yellow": "Entirely Yellow Plain",
  "block.minecraft.banner.border.black": "Black Bordure",
  "block.minecraft.banner.border.blue": "Blue Bordure",
  "block.minecraft.banner.border.brown": "Brown Bordure",
  "block.minecraft.banner.border.cyan": "Turquoise Bordure",
  "block.minecraft.banner.border.gray": "Grey Bordure",
  "block.minecraft.banner.border.green": "Green Bordure",
  "block.minecraft.banner.border.light_blue": "Whey Bordure",
  "block.minecraft.banner.border.light_gray": "Pale Grey Bordure",
  "block.minecraft.banner.border.lime": "Lincoln Bordure",
  "block.minecraft.banner.border.magenta": "Mulberry Bordure",
  "block.minecraft.banner.border.orange": "Tawny Bordure",
  "block.minecraft.banner.border.pink": "Carnation Bordure",
  "block.minecraft.banner.border.purple": "Purple Bordure",
  "block.minecraft.banner.border.red": "Red Bordure",
  "block.minecraft.banner.border.white": "White Bordure",
  "block.minecraft.banner.border.yellow": "Yellow Bordure",
  "block.minecraft.banner.bricks.black": "Black Field Masoned",
  "block.minecraft.banner.bricks.blue": "Blue Field Masoned",
  "block.minecraft.banner.bricks.brown": "Brown Field Masoned",
  "block.minecraft.banner.bricks.cyan": "Turquoise Field Masoned",
  "block.minecraft.banner.bricks.gray": "Grey Field Masoned",
  "block.minecraft.banner.bricks.green": "Green Field Masoned",
  "block.minecraft.banner.bricks.light_blue": "Whey Field Masoned",
  "block.minecraft.banner.bricks.light_gray": "Pale Grey Field Masoned",
  "block.minecraft.banner.bricks.lime": "Lincoln Field Masoned",
  "block.minecraft.banner.bricks.magenta": "Mulberry Field Masoned",
  "block.minecraft.banner.bricks.orange": "Tawny Field Masoned",
  "block.minecraft.banner.bricks.pink": "Carnation Field Masoned",
  "block.minecraft.banner.bricks.purple": "Purple Field Masoned",
  "block.minecraft.banner.bricks.red": "Red Field Masoned",
  "block.minecraft.banner.bricks.white": "White Field Masoned",
  "block.minecraft.banner.bricks.yellow": "Yellow Field Masoned",
  "block.minecraft.banner.circle.black": "Black Roundel",
  "block.minecraft.banner.circle.blue": "Blue Roundel",
  "block.minecraft.banner.circle.brown": "Brown Roundel",
  "block.minecraft.banner.circle.cyan": "Turquoise Roundel",
  "block.minecraft.banner.circle.gray": "Grey Roundel",
  "block.minecraft.banner.circle.green": "Green Roundel",
  "block.minecraft.banner.circle.light_blue": "Whey Roundel",
  "block.minecraft.banner.circle.light_gray": "Pale Grey Roundel",
  "block.minecraft.banner.circle.lime": "Lincoln Roundel",
  "block.minecraft.banner.circle.magenta": "Mulberry Roundel",
  "block.minecraft.banner.circle.orange": "Tawny Roundel",
  "block.minecraft.banner.circle.pink": "Carnation Roundel",
  "block.minecraft.banner.circle.purple": "Purple Roundel",
  "block.minecraft.banner.circle.red": "Red Roundel",
  "block.minecraft.banner.circle.white": "White Roundel",
  "block.minecraft.banner.circle.yellow": "Yellow Roundel",
  "block.minecraft.banner.creeper.black": "Black Creeper Charge",
  "block.minecraft.banner.creeper.blue": "Blue Creeper Charge",
  "block.minecraft.banner.creeper.brown": "Brown Creeper Charge",
  "block.minecraft.banner.creeper.cyan": "Turquoise Creeper Charge",
  "block.minecraft.banner.creeper.gray": "Grey Creeper Charge",
  "block.minecraft.banner.creeper.green": "Green Creeper Charge",
  "block.minecraft.banner.creeper.light_blue": "Whey Creeper Charge",
  "block.minecraft.banner.creeper.light_gray": "Pale Grey Creeper Charge",
  "block.minecraft.banner.creeper.lime": "Lincoln Creeper Charge",
  "block.minecraft.banner.creeper.magenta": "Mulberry Creeper Charge",
  "block.minecraft.banner.creeper.orange": "Tawny Creeper Charge",
  "block.minecraft.banner.creeper.pink": "Carnation Creeper Charge",
  "block.minecraft.banner.creeper.purple": "Purple Creeper Charge",
  "block.minecraft.banner.creeper.red": "Red Creeper Charge",
  "block.minecraft.banner.creeper.white": "White Creeper Charge",
  "block.minecraft.banner.creeper.yellow": "Yellow Creeper Charge",
  "block.minecraft.banner.cross.black": "Black Saltire",
  "block.minecraft.banner.cross.blue": "Blue Saltire",
  "block.minecraft.banner.cross.brown": "Brown Saltire",
  "block.minecraft.banner.cross.cyan": "Turquoise Saltire",
  "block.minecraft.banner.cross.gray": "Grey Saltire",
  "block.minecraft.banner.cross.green": "Green Saltire",
  "block.minecraft.banner.cross.light_blue": "Whey Saltire",
  "block.minecraft.banner.cross.light_gray": "Pale Grey Saltire",
  "block.minecraft.banner.cross.lime": "Lincoln Saltire",
  "block.minecraft.banner.cross.magenta": "Mulberry Saltire",
  "block.minecraft.banner.cross.orange": "Tawny Saltire",
  "block.minecraft.banner.cross.pink": "Carnation Saltire",
  "block.minecraft.banner.cross.purple": "Purple Saltire",
  "block.minecraft.banner.cross.red": "Red Saltire",
  "block.minecraft.banner.cross.white": "White Saltire",
  "block.minecraft.banner.cross.yellow": "Yellow Saltire",
  "block.minecraft.banner.curly_border.black": "Black Bordure Indented",
  "block.minecraft.banner.curly_border.blue": "Blue Bordure Indented",
  "block.minecraft.banner.curly_border.brown": "Brown Bordure Indented",
  "block.minecraft.banner.curly_border.cyan": "Turquoise Bordure Indented",
  "block.minecraft.banner.curly_border.gray": "Grey Bordure Indented",
  "block.minecraft.banner.curly_border.green": "Green Bordure Indented",
  "block.minecraft.banner.curly_border.light_blue": "Whey Bordure Indented",
  "block.minecraft.banner.curly_border.light_gray": "Pale Grey Bordure Indented",
  "block.minecraft.banner.curly_border.lime": "Lincoln Bordure Indented",
  "block.minecraft.banner.curly_border.magenta": "Mulberry Bordure Indented",
  "block.minecraft.banner.curly_border.orange": "Tawny Bordure Indented",
  "block.minecraft.banner.curly_border.pink": "Carnation Bordure Indented",
  "block.minecraft.banner.curly_border.purple": "Purple Bordure Indented",
  "block.minecraft.banner.curly_border.red": "Red Bordure Indented",
  "block.minecraft.banner.curly_border.white": "White Bordure Indented",
  "block.minecraft.banner.curly_border.yellow": "Yellow Bordure Indented",
  "block.minecraft.banner.diagonal_left.black": "Black Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.blue": "Blue Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.brown": "Brown Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.cyan": "Turquoise Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.gray": "Grey Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.green": "Green Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.light_blue": "Whey Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.light_gray": "Pale Grey Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.lime": "Lincoln Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.magenta": "Mulberry Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.orange": "Tawny Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.pink": "Carnation Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.purple": "Purple Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.red": "Red Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.white": "White Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.yellow": "Yellow Per Bend Sinister",
  "block.minecraft.banner.diagonal_right.black": "Black Per Bend",
  "block.minecraft.banner.diagonal_right.blue": "Blue Per Bend",
  "block.minecraft.banner.diagonal_right.brown": "Brown Per Bend",
  "block.minecraft.banner.diagonal_right.cyan": "Turquoise Per Bend",
  "block.minecraft.banner.diagonal_right.gray": "Grey Per Bend",
  "block.minecraft.banner.diagonal_right.green": "Green Per Bend",
  "block.minecraft.banner.diagonal_right.light_blue": "Whey Per Bend",
  "block.minecraft.banner.diagonal_right.light_gray": "Pale Grey Per Bend",
  "block.minecraft.banner.diagonal_right.lime": "Lincoln Per Bend",
  "block.minecraft.banner.diagonal_right.magenta": "Mulberry Per Bend",
  "block.minecraft.banner.diagonal_right.orange": "Tawny Per Bend",
  "block.minecraft.banner.diagonal_right.pink": "Carnation Per Bend",
  "block.minecraft.banner.diagonal_right.purple": "Purple Per Bend",
  "block.minecraft.banner.diagonal_right.red": "Red Per Bend",
  "block.minecraft.banner.diagonal_right.white": "White Per Bend",
  "block.minecraft.banner.diagonal_right.yellow": "Yellow Per Bend",
  "block.minecraft.banner.diagonal_up_left.black": "Black Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.blue": "Blue Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.brown": "Brown Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.cyan": "Turquoise Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.gray": "Grey Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.green": "Green Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Whey Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Pale Grey Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.lime": "Lincoln Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.magenta": "Mulberry Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.orange": "Tawny Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.pink": "Carnation Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.purple": "Purple Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.red": "Red Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.white": "White Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.yellow": "Yellow Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_right.black": "Black Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.blue": "Blue Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.brown": "Brown Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.cyan": "Turquoise Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.gray": "Grey Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.green": "Green Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Whey Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Pale Grey Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.lime": "Lincoln Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.magenta": "Mulberry Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.orange": "Tawny Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.pink": "Carnation Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.purple": "Purple Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.red": "Red Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.white": "White Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.yellow": "Yellow Per Bend Sinister Inverted",
  "block.minecraft.banner.flow.black": "Black Current",
  "block.minecraft.banner.flow.blue": "Blue Current",
  "block.minecraft.banner.flow.brown": "Brown Current",
  "block.minecraft.banner.flow.cyan": "Turquoise Current",
  "block.minecraft.banner.flow.gray": "Grey Current",
  "block.minecraft.banner.flow.green": "Green Current",
  "block.minecraft.banner.flow.light_blue": "Whey Current",
  "block.minecraft.banner.flow.light_gray": "Pale Grey Current",
  "block.minecraft.banner.flow.lime": "Lincoln Current",
  "block.minecraft.banner.flow.magenta": "Mulberry Current",
  "block.minecraft.banner.flow.orange": "Tawny Current",
  "block.minecraft.banner.flow.pink": "Carnation Current",
  "block.minecraft.banner.flow.purple": "Purple Current",
  "block.minecraft.banner.flow.red": "Red Current",
  "block.minecraft.banner.flow.white": "White Current",
  "block.minecraft.banner.flow.yellow": "Yellow Current",
  "block.minecraft.banner.flower.black": "Black Flower Charge",
  "block.minecraft.banner.flower.blue": "Blue Flower Charge",
  "block.minecraft.banner.flower.brown": "Brown Flower Charge",
  "block.minecraft.banner.flower.cyan": "Turquoise Flower Charge",
  "block.minecraft.banner.flower.gray": "Grey Flower Charge",
  "block.minecraft.banner.flower.green": "Green Flower Charge",
  "block.minecraft.banner.flower.light_blue": "Whey Flower Charge",
  "block.minecraft.banner.flower.light_gray": "Pale Grey Flower Charge",
  "block.minecraft.banner.flower.lime": "Lincoln Flower Charge",
  "block.minecraft.banner.flower.magenta": "Mulberry Flower Charge",
  "block.minecraft.banner.flower.orange": "Tawny Flower Charge",
  "block.minecraft.banner.flower.pink": "Carnation Flower Charge",
  "block.minecraft.banner.flower.purple": "Purple Flower Charge",
  "block.minecraft.banner.flower.red": "Red Flower Charge",
  "block.minecraft.banner.flower.white": "White Flower Charge",
  "block.minecraft.banner.flower.yellow": "Yellow Flower Charge",
  "block.minecraft.banner.globe.black": "Black Globe",
  "block.minecraft.banner.globe.blue": "Blue Globe",
  "block.minecraft.banner.globe.brown": "Brown Globe",
  "block.minecraft.banner.globe.cyan": "Turquoise Globe",
  "block.minecraft.banner.globe.gray": "Grey Globe",
  "block.minecraft.banner.globe.green": "Green Globe",
  "block.minecraft.banner.globe.light_blue": "Whey Globe",
  "block.minecraft.banner.globe.light_gray": "Pale Grey Globe",
  "block.minecraft.banner.globe.lime": "Lincoln Globe",
  "block.minecraft.banner.globe.magenta": "Mulberry Globe",
  "block.minecraft.banner.globe.orange": "Tawny Globe",
  "block.minecraft.banner.globe.pink": "Carnation Globe",
  "block.minecraft.banner.globe.purple": "Purple Globe",
  "block.minecraft.banner.globe.red": "Red globe",
  "block.minecraft.banner.globe.white": "White Globe",
  "block.minecraft.banner.globe.yellow": "Yellow Globe",
  "block.minecraft.banner.gradient.black": "Black Gradient",
  "block.minecraft.banner.gradient.blue": "Blue Gradient",
  "block.minecraft.banner.gradient.brown": "Brown Gradient",
  "block.minecraft.banner.gradient.cyan": "Turquoise Gradient",
  "block.minecraft.banner.gradient.gray": "Grey Gradient",
  "block.minecraft.banner.gradient.green": "Green Gradient",
  "block.minecraft.banner.gradient.light_blue": "Whey Gradient",
  "block.minecraft.banner.gradient.light_gray": "Pale Grey Gradient",
  "block.minecraft.banner.gradient.lime": "Lincoln Gradient",
  "block.minecraft.banner.gradient.magenta": "Mulberry Gradient",
  "block.minecraft.banner.gradient.orange": "Tawny Gradient",
  "block.minecraft.banner.gradient.pink": "Carnation Gradient",
  "block.minecraft.banner.gradient.purple": "Purple Gradient",
  "block.minecraft.banner.gradient.red": "Red Gradient",
  "block.minecraft.banner.gradient.white": "White Gradient",
  "block.minecraft.banner.gradient.yellow": "Yellow Gradient",
  "block.minecraft.banner.gradient_up.black": "Black Base Gradient",
  "block.minecraft.banner.gradient_up.blue": "Blue Base Gradient",
  "block.minecraft.banner.gradient_up.brown": "Brown Base Gradient",
  "block.minecraft.banner.gradient_up.cyan": "Turquoise Base Gradient",
  "block.minecraft.banner.gradient_up.gray": "Grey Base Gradient",
  "block.minecraft.banner.gradient_up.green": "Green Base Gradient",
  "block.minecraft.banner.gradient_up.light_blue": "Whey Base Gradient",
  "block.minecraft.banner.gradient_up.light_gray": "Pale Grey Base Gradient",
  "block.minecraft.banner.gradient_up.lime": "Lincoln Base Gradient",
  "block.minecraft.banner.gradient_up.magenta": "Mulberry Base Gradient",
  "block.minecraft.banner.gradient_up.orange": "Tawny Base Gradient",
  "block.minecraft.banner.gradient_up.pink": "Carnation Base Gradient",
  "block.minecraft.banner.gradient_up.purple": "Purple Base Gradient",
  "block.minecraft.banner.gradient_up.red": "Red Base Gradient",
  "block.minecraft.banner.gradient_up.white": "White Base Gradient",
  "block.minecraft.banner.gradient_up.yellow": "Yellow Base Gradient",
  "block.minecraft.banner.guster.black": "Black Gust",
  "block.minecraft.banner.guster.blue": "Blue Gust",
  "block.minecraft.banner.guster.brown": "Brown Gust",
  "block.minecraft.banner.guster.cyan": "Turquoise Gust",
  "block.minecraft.banner.guster.gray": "Grey Gust",
  "block.minecraft.banner.guster.green": "Green Gust",
  "block.minecraft.banner.guster.light_blue": "Whey Gust",
  "block.minecraft.banner.guster.light_gray": "Pale Grey Gust",
  "block.minecraft.banner.guster.lime": "Lincoln Gust",
  "block.minecraft.banner.guster.magenta": "Mulberry Gust",
  "block.minecraft.banner.guster.orange": "Tawny Gust",
  "block.minecraft.banner.guster.pink": "Carnation Gust",
  "block.minecraft.banner.guster.purple": "Purple Gust",
  "block.minecraft.banner.guster.red": "Red Gust",
  "block.minecraft.banner.guster.white": "White Gust",
  "block.minecraft.banner.guster.yellow": "Yellow Gust",
  "block.minecraft.banner.half_horizontal.black": "Black Per Fess",
  "block.minecraft.banner.half_horizontal.blue": "Blue Per Fess",
  "block.minecraft.banner.half_horizontal.brown": "Brown Per Fess",
  "block.minecraft.banner.half_horizontal.cyan": "Turquoise Per Fess",
  "block.minecraft.banner.half_horizontal.gray": "Grey Per Fess",
  "block.minecraft.banner.half_horizontal.green": "Green Per Fess",
  "block.minecraft.banner.half_horizontal.light_blue": "Whey Per Fess",
  "block.minecraft.banner.half_horizontal.light_gray": "Pale Grey Per Fess",
  "block.minecraft.banner.half_horizontal.lime": "Lincoln Per Fess",
  "block.minecraft.banner.half_horizontal.magenta": "Mulberry Per Fess",
  "block.minecraft.banner.half_horizontal.orange": "Tawny Per Fess",
  "block.minecraft.banner.half_horizontal.pink": "Carnation Per Fess",
  "block.minecraft.banner.half_horizontal.purple": "Purple Per Fess",
  "block.minecraft.banner.half_horizontal.red": "Red Per Fess",
  "block.minecraft.banner.half_horizontal.white": "White Per Fess",
  "block.minecraft.banner.half_horizontal.yellow": "Yellow Per Fess",
  "block.minecraft.banner.half_horizontal_bottom.black": "Black Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Blue Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Brown Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Turquoise Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Grey Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.green": "Green Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Whey Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Pale Grey Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Lincoln Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Mulberry Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Tawny Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Carnation Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Purple Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.red": "Red Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.white": "White Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Yellow Per Fess Inverted",
  "block.minecraft.banner.half_vertical.black": "Black Per Pale",
  "block.minecraft.banner.half_vertical.blue": "Blue Per Pale",
  "block.minecraft.banner.half_vertical.brown": "Brown Per Pale",
  "block.minecraft.banner.half_vertical.cyan": "Turquoise Per Pale",
  "block.minecraft.banner.half_vertical.gray": "Grey Per Pale",
  "block.minecraft.banner.half_vertical.green": "Green Per Pale",
  "block.minecraft.banner.half_vertical.light_blue": "Whey Per Pale",
  "block.minecraft.banner.half_vertical.light_gray": "Pale Grey Per Pale",
  "block.minecraft.banner.half_vertical.lime": "Lincoln Per Pale",
  "block.minecraft.banner.half_vertical.magenta": "Mulberry Per Pale",
  "block.minecraft.banner.half_vertical.orange": "Tawny Per Pale",
  "block.minecraft.banner.half_vertical.pink": "Carnation Per Pale",
  "block.minecraft.banner.half_vertical.purple": "Purple Per Pale",
  "block.minecraft.banner.half_vertical.red": "Red Per Pale",
  "block.minecraft.banner.half_vertical.white": "White Per Pale",
  "block.minecraft.banner.half_vertical.yellow": "Yellow Per Pale",
  "block.minecraft.banner.half_vertical_right.black": "Black Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.blue": "Blue Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.brown": "Brown Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.cyan": "Turquoise Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.gray": "Grey Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.green": "Green Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.light_blue": "Whey Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.light_gray": "Pale Grey Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.lime": "Lincoln Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.magenta": "Mulberry Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.orange": "Tawny Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.pink": "Carnation Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.purple": "Purple Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.red": "Red Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.white": "White Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.yellow": "Yellow Per Pale Inverted",
  "block.minecraft.banner.mojang.black": "Black Emblem",
  "block.minecraft.banner.mojang.blue": "Blue Emblem",
  "block.minecraft.banner.mojang.brown": "Brown Emblem",
  "block.minecraft.banner.mojang.cyan": "Turquoise Emblem",
  "block.minecraft.banner.mojang.gray": "Grey Emblem",
  "block.minecraft.banner.mojang.green": "Green Emblem",
  "block.minecraft.banner.mojang.light_blue": "Whey Emblem",
  "block.minecraft.banner.mojang.light_gray": "Pale Grey Emblem",
  "block.minecraft.banner.mojang.lime": "Lincoln Emblem",
  "block.minecraft.banner.mojang.magenta": "Mulberry Emblem",
  "block.minecraft.banner.mojang.orange": "Tawny Emblem",
  "block.minecraft.banner.mojang.pink": "Carnation Emblem",
  "block.minecraft.banner.mojang.purple": "Purple Emblem",
  "block.minecraft.banner.mojang.red": "Red Emblem",
  "block.minecraft.banner.mojang.white": "White Emblem",
  "block.minecraft.banner.mojang.yellow": "Yellow Emblem",
  "block.minecraft.banner.piglin.black": "Black Snout",
  "block.minecraft.banner.piglin.blue": "Blue Snout",
  "block.minecraft.banner.piglin.brown": "Brown Snout",
  "block.minecraft.banner.piglin.cyan": "Turquoise Snout",
  "block.minecraft.banner.piglin.gray": "Grey Snout",
  "block.minecraft.banner.piglin.green": "Green Snout",
  "block.minecraft.banner.piglin.light_blue": "Whey Snout",
  "block.minecraft.banner.piglin.light_gray": "Pale Grey Snout",
  "block.minecraft.banner.piglin.lime": "Lincoln Snout",
  "block.minecraft.banner.piglin.magenta": "Mulberry Snout",
  "block.minecraft.banner.piglin.orange": "Tawny Snout",
  "block.minecraft.banner.piglin.pink": "Carnation Snout",
  "block.minecraft.banner.piglin.purple": "Purple Snout",
  "block.minecraft.banner.piglin.red": "Red Snout",
  "block.minecraft.banner.piglin.white": "White Snout",
  "block.minecraft.banner.piglin.yellow": "Yellow Snout",
  "block.minecraft.banner.rhombus.black": "Black Lozenge",
  "block.minecraft.banner.rhombus.blue": "Blue Lozenge",
  "block.minecraft.banner.rhombus.brown": "Brown Lozenge",
  "block.minecraft.banner.rhombus.cyan": "Turquoise Lozenge",
  "block.minecraft.banner.rhombus.gray": "Grey Lozenge",
  "block.minecraft.banner.rhombus.green": "Green Lozenge",
  "block.minecraft.banner.rhombus.light_blue": "Whey Lozenge",
  "block.minecraft.banner.rhombus.light_gray": "Pale Grey Lozenge",
  "block.minecraft.banner.rhombus.lime": "Lincoln Lozenge",
  "block.minecraft.banner.rhombus.magenta": "Mulberry Lozenge",
  "block.minecraft.banner.rhombus.orange": "Tawny Lozenge",
  "block.minecraft.banner.rhombus.pink": "Carnation Lozenge",
  "block.minecraft.banner.rhombus.purple": "Purple Lozenge",
  "block.minecraft.banner.rhombus.red": "Red Lozenge",
  "block.minecraft.banner.rhombus.white": "White Lozenge",
  "block.minecraft.banner.rhombus.yellow": "Yellow Lozenge",
  "block.minecraft.banner.skull.black": "Black Skull Charge",
  "block.minecraft.banner.skull.blue": "Blue Skull Charge",
  "block.minecraft.banner.skull.brown": "Brown Skull Charge",
  "block.minecraft.banner.skull.cyan": "Turquoise Skull Charge",
  "block.minecraft.banner.skull.gray": "Grey Skull Charge",
  "block.minecraft.banner.skull.green": "Green Skull Charge",
  "block.minecraft.banner.skull.light_blue": "Whey Skull Charge",
  "block.minecraft.banner.skull.light_gray": "Pale Grey Skull Charge",
  "block.minecraft.banner.skull.lime": "Lincoln Skull Charge",
  "block.minecraft.banner.skull.magenta": "Mulberry Skull Charge",
  "block.minecraft.banner.skull.orange": "Tawny Skull Charge",
  "block.minecraft.banner.skull.pink": "Carnation Skull Charge",
  "block.minecraft.banner.skull.purple": "Purple Skull Charge",
  "block.minecraft.banner.skull.red": "Red Skull Charge",
  "block.minecraft.banner.skull.white": "White Skull Charge",
  "block.minecraft.banner.skull.yellow": "Yellow Skull Charge",
  "block.minecraft.banner.small_stripes.black": "Black Paly",
  "block.minecraft.banner.small_stripes.blue": "Blue Paly",
  "block.minecraft.banner.small_stripes.brown": "Brown Paly",
  "block.minecraft.banner.small_stripes.cyan": "Turquoise Paly",
  "block.minecraft.banner.small_stripes.gray": "Grey Paly",
  "block.minecraft.banner.small_stripes.green": "Green Paly",
  "block.minecraft.banner.small_stripes.light_blue": "Whey Paly",
  "block.minecraft.banner.small_stripes.light_gray": "Pale Grey Paly",
  "block.minecraft.banner.small_stripes.lime": "Lincoln Paly",
  "block.minecraft.banner.small_stripes.magenta": "Mulberry Paly",
  "block.minecraft.banner.small_stripes.orange": "Tawny Paly",
  "block.minecraft.banner.small_stripes.pink": "Carnation Paly",
  "block.minecraft.banner.small_stripes.purple": "Purple Paly",
  "block.minecraft.banner.small_stripes.red": "Red Paly",
  "block.minecraft.banner.small_stripes.white": "White Paly",
  "block.minecraft.banner.small_stripes.yellow": "Yellow Paly",
  "block.minecraft.banner.square_bottom_left.black": "Black Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.blue": "Blue Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.brown": "Brown Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.cyan": "Turquoise Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.gray": "Grey Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.green": "Green Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.light_blue": "Whey Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.light_gray": "Pale Grey Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.lime": "Lincoln Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.magenta": "Mulberry Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.orange": "Tawny Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.pink": "Carnation Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.purple": "Purple Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.red": "Red Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.white": "White Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.yellow": "Yellow Base Dexter Canton",
  "block.minecraft.banner.square_bottom_right.black": "Black Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.blue": "Blue Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.brown": "Brown Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.cyan": "Turquoise Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.gray": "Grey Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.green": "Green Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.light_blue": "Whey Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.light_gray": "Pale Grey Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.lime": "Lincoln Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.magenta": "Mulberry Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.orange": "Tawny Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.pink": "Carnation Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.purple": "Purple Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.red": "Red Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.white": "White Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.yellow": "Yellow Base Sinister Canton",
  "block.minecraft.banner.square_top_left.black": "Black Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.blue": "Blue Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.brown": "Brown Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.cyan": "Turquoise Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.gray": "Grey Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.green": "Green Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.light_blue": "Whey Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.light_gray": "Pale Grey Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.lime": "Lincoln Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.magenta": "Mulberry Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.orange": "Tawny Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.pink": "Carnation Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.purple": "Purple Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.red": "Red Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.white": "White Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.yellow": "Yellow Chief Dexter Canton",
  "block.minecraft.banner.square_top_right.black": "Black Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.blue": "Blue Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.brown": "Brown Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.cyan": "Turquoise Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.gray": "Grey Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.green": "Green Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.light_blue": "Whey Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.light_gray": "Pale Grey Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.lime": "Lincoln Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.magenta": "Mulberry Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.orange": "Tawny Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.pink": "Carnation Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.purple": "Purple Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.red": "Red Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.white": "White Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.yellow": "Yellow Chief Sinister Canton",
  "block.minecraft.banner.straight_cross.black": "Black Cross",
  "block.minecraft.banner.straight_cross.blue": "Blue Cross",
  "block.minecraft.banner.straight_cross.brown": "Brown Cross",
  "block.minecraft.banner.straight_cross.cyan": "Turquoise Cross",
  "block.minecraft.banner.straight_cross.gray": "Grey Cross",
  "block.minecraft.banner.straight_cross.green": "Green Cross",
  "block.minecraft.banner.straight_cross.light_blue": "Whey Cross",
  "block.minecraft.banner.straight_cross.light_gray": "Pale Grey Cross",
  "block.minecraft.banner.straight_cross.lime": "Lincoln Cross",
  "block.minecraft.banner.straight_cross.magenta": "Mulberry Cross",
  "block.minecraft.banner.straight_cross.orange": "Tawny Cross",
  "block.minecraft.banner.straight_cross.pink": "Carnation Cross",
  "block.minecraft.banner.straight_cross.purple": "Purple Cross",
  "block.minecraft.banner.straight_cross.red": "Red Cross",
  "block.minecraft.banner.straight_cross.white": "White Cross",
  "block.minecraft.banner.straight_cross.yellow": "Yellow Cross",
  "block.minecraft.banner.stripe_bottom.black": "Black Base",
  "block.minecraft.banner.stripe_bottom.blue": "Blue Base",
  "block.minecraft.banner.stripe_bottom.brown": "Brown Base",
  "block.minecraft.banner.stripe_bottom.cyan": "Turquoise Base",
  "block.minecraft.banner.stripe_bottom.gray": "Grey Base",
  "block.minecraft.banner.stripe_bottom.green": "Green Base",
  "block.minecraft.banner.stripe_bottom.light_blue": "Whey Base",
  "block.minecraft.banner.stripe_bottom.light_gray": "Pale Grey Base",
  "block.minecraft.banner.stripe_bottom.lime": "Lincoln Base",
  "block.minecraft.banner.stripe_bottom.magenta": "Mulberry Base",
  "block.minecraft.banner.stripe_bottom.orange": "Tawny Base",
  "block.minecraft.banner.stripe_bottom.pink": "Carnation Base",
  "block.minecraft.banner.stripe_bottom.purple": "Purple Base",
  "block.minecraft.banner.stripe_bottom.red": "Red Base",
  "block.minecraft.banner.stripe_bottom.white": "White Base",
  "block.minecraft.banner.stripe_bottom.yellow": "Yellow Base",
  "block.minecraft.banner.stripe_center.black": "Black Pale",
  "block.minecraft.banner.stripe_center.blue": "Blue Pale",
  "block.minecraft.banner.stripe_center.brown": "Brown Pale",
  "block.minecraft.banner.stripe_center.cyan": "Turquoise Pale",
  "block.minecraft.banner.stripe_center.gray": "Grey Pale",
  "block.minecraft.banner.stripe_center.green": "Green Pale",
  "block.minecraft.banner.stripe_center.light_blue": "Whey Pale",
  "block.minecraft.banner.stripe_center.light_gray": "Pale Grey Pale",
  "block.minecraft.banner.stripe_center.lime": "Lincoln Pale",
  "block.minecraft.banner.stripe_center.magenta": "Mulberry Pale",
  "block.minecraft.banner.stripe_center.orange": "Tawny Pale",
  "block.minecraft.banner.stripe_center.pink": "Carnation Pale",
  "block.minecraft.banner.stripe_center.purple": "Purple Pale",
  "block.minecraft.banner.stripe_center.red": "Red Pale",
  "block.minecraft.banner.stripe_center.white": "White Pale",
  "block.minecraft.banner.stripe_center.yellow": "Yellow Pale",
  "block.minecraft.banner.stripe_downleft.black": "Black Bend Sinister",
  "block.minecraft.banner.stripe_downleft.blue": "Blue Bend Sinister",
  "block.minecraft.banner.stripe_downleft.brown": "Brown Bend Sinister",
  "block.minecraft.banner.stripe_downleft.cyan": "Turquoise Bend Sinister",
  "block.minecraft.banner.stripe_downleft.gray": "Grey Bend Sinister",
  "block.minecraft.banner.stripe_downleft.green": "Green Bend Sinister",
  "block.minecraft.banner.stripe_downleft.light_blue": "Whey Bend Sinister",
  "block.minecraft.banner.stripe_downleft.light_gray": "Pale Grey Bend Sinister",
  "block.minecraft.banner.stripe_downleft.lime": "Lincoln Bend Sinister",
  "block.minecraft.banner.stripe_downleft.magenta": "Mulberry Bend Sinister",
  "block.minecraft.banner.stripe_downleft.orange": "Tawny Bend Sinister",
  "block.minecraft.banner.stripe_downleft.pink": "Carnation Bend Sinister",
  "block.minecraft.banner.stripe_downleft.purple": "Purple Bend Sinister",
  "block.minecraft.banner.stripe_downleft.red": "Red Bend Sinister",
  "block.minecraft.banner.stripe_downleft.white": "White Bend Sinister",
  "block.minecraft.banner.stripe_downleft.yellow": "Yellow Bend Sinister",
  "block.minecraft.banner.stripe_downright.black": "Black Bend",
  "block.minecraft.banner.stripe_downright.blue": "Blue Bend",
  "block.minecraft.banner.stripe_downright.brown": "Brown Bend",
  "block.minecraft.banner.stripe_downright.cyan": "Turquoise Bend",
  "block.minecraft.banner.stripe_downright.gray": "Grey Bend",
  "block.minecraft.banner.stripe_downright.green": "Green Bend",
  "block.minecraft.banner.stripe_downright.light_blue": "Whey Bend",
  "block.minecraft.banner.stripe_downright.light_gray": "Pale Grey Bend",
  "block.minecraft.banner.stripe_downright.lime": "Lincoln Bend",
  "block.minecraft.banner.stripe_downright.magenta": "Mulberry Bend",
  "block.minecraft.banner.stripe_downright.orange": "Tawny Bend",
  "block.minecraft.banner.stripe_downright.pink": "Carnation Bend",
  "block.minecraft.banner.stripe_downright.purple": "Purple Bend",
  "block.minecraft.banner.stripe_downright.red": "Red Bend",
  "block.minecraft.banner.stripe_downright.white": "White Bend",
  "block.minecraft.banner.stripe_downright.yellow": "Yellow Bend",
  "block.minecraft.banner.stripe_left.black": "Black Pale Dexter",
  "block.minecraft.banner.stripe_left.blue": "Blue Pale Dexter",
  "block.minecraft.banner.stripe_left.brown": "Brown Pale Dexter",
  "block.minecraft.banner.stripe_left.cyan": "Turquoise Pale Dexter",
  "block.minecraft.banner.stripe_left.gray": "Grey Pale Dexter",
  "block.minecraft.banner.stripe_left.green": "Green Pale Dexter",
  "block.minecraft.banner.stripe_left.light_blue": "Whey Pale Dexter",
  "block.minecraft.banner.stripe_left.light_gray": "Pale Grey Pale Dexter",
  "block.minecraft.banner.stripe_left.lime": "Lincoln Pale Dexter",
  "block.minecraft.banner.stripe_left.magenta": "Mulberry Pale Dexter",
  "block.minecraft.banner.stripe_left.orange": "Tawny Pale Dexter",
  "block.minecraft.banner.stripe_left.pink": "Carnation Pale Dexter",
  "block.minecraft.banner.stripe_left.purple": "Purple Pale Dexter",
  "block.minecraft.banner.stripe_left.red": "Red Pale Dexter",
  "block.minecraft.banner.stripe_left.white": "White Pale Dexter",
  "block.minecraft.banner.stripe_left.yellow": "Yellow Pale Dexter",
  "block.minecraft.banner.stripe_middle.black": "Black Fess",
  "block.minecraft.banner.stripe_middle.blue": "Blue Fess",
  "block.minecraft.banner.stripe_middle.brown": "Brown Fess",
  "block.minecraft.banner.stripe_middle.cyan": "Turquoise Fess",
  "block.minecraft.banner.stripe_middle.gray": "Grey Fess",
  "block.minecraft.banner.stripe_middle.green": "Green Fess",
  "block.minecraft.banner.stripe_middle.light_blue": "Whey Fess",
  "block.minecraft.banner.stripe_middle.light_gray": "Pale Grey Fess",
  "block.minecraft.banner.stripe_middle.lime": "Lincoln Fess",
  "block.minecraft.banner.stripe_middle.magenta": "Mulberry Fess",
  "block.minecraft.banner.stripe_middle.orange": "Tawny Fess",
  "block.minecraft.banner.stripe_middle.pink": "Carnation Fess",
  "block.minecraft.banner.stripe_middle.purple": "Purple Fess",
  "block.minecraft.banner.stripe_middle.red": "Red Fess",
  "block.minecraft.banner.stripe_middle.white": "White Fess",
  "block.minecraft.banner.stripe_middle.yellow": "Yellow Fess",
  "block.minecraft.banner.stripe_right.black": "Black Pale Sinister",
  "block.minecraft.banner.stripe_right.blue": "Blue Pale Sinister",
  "block.minecraft.banner.stripe_right.brown": "Brown Pale Sinister",
  "block.minecraft.banner.stripe_right.cyan": "Turquoise Pale Sinister",
  "block.minecraft.banner.stripe_right.gray": "Grey Pale Sinister",
  "block.minecraft.banner.stripe_right.green": "Green Pale Sinister",
  "block.minecraft.banner.stripe_right.light_blue": "Whey Pale Sinister",
  "block.minecraft.banner.stripe_right.light_gray": "Pale Grey Pale Sinister",
  "block.minecraft.banner.stripe_right.lime": "Lincoln Pale Sinister",
  "block.minecraft.banner.stripe_right.magenta": "Mulberry Pale Sinister",
  "block.minecraft.banner.stripe_right.orange": "Tawny Pale Sinister",
  "block.minecraft.banner.stripe_right.pink": "Carnation Pale Sinister",
  "block.minecraft.banner.stripe_right.purple": "Purple Pale Sinister",
  "block.minecraft.banner.stripe_right.red": "Red Pale Sinister",
  "block.minecraft.banner.stripe_right.white": "White Pale Sinister",
  "block.minecraft.banner.stripe_right.yellow": "Yellow Pale Sinister",
  "block.minecraft.banner.stripe_top.black": "Black Chief",
  "block.minecraft.banner.stripe_top.blue": "Blue Chief",
  "block.minecraft.banner.stripe_top.brown": "Brown Chief",
  "block.minecraft.banner.stripe_top.cyan": "Turquoise Chief",
  "block.minecraft.banner.stripe_top.gray": "Grey Chief",
  "block.minecraft.banner.stripe_top.green": "Green Chief",
  "block.minecraft.banner.stripe_top.light_blue": "Whey Chief",
  "block.minecraft.banner.stripe_top.light_gray": "Pale Grey Chief",
  "block.minecraft.banner.stripe_top.lime": "Lincoln Chief",
  "block.minecraft.banner.stripe_top.magenta": "Mulberry Chief",
  "block.minecraft.banner.stripe_top.orange": "Tawny Chief",
  "block.minecraft.banner.stripe_top.pink": "Carnation Chief",
  "block.minecraft.banner.stripe_top.purple": "Purple Chief",
  "block.minecraft.banner.stripe_top.red": "Red Chief",
  "block.minecraft.banner.stripe_top.white": "White Chief",
  "block.minecraft.banner.stripe_top.yellow": "Yellow Chief",
  "block.minecraft.banner.triangle_bottom.black": "Black Chevron",
  "block.minecraft.banner.triangle_bottom.blue": "Blue Chevron",
  "block.minecraft.banner.triangle_bottom.brown": "Brown Chevron",
  "block.minecraft.banner.triangle_bottom.cyan": "Turquoise Chevron",
  "block.minecraft.banner.triangle_bottom.gray": "Grey Chevron",
  "block.minecraft.banner.triangle_bottom.green": "Green Chevron",
  "block.minecraft.banner.triangle_bottom.light_blue": "Whey Chevron",
  "block.minecraft.banner.triangle_bottom.light_gray": "Pale Grey Chevron",
  "block.minecraft.banner.triangle_bottom.lime": "Lincoln Chevron",
  "block.minecraft.banner.triangle_bottom.magenta": "Mulberry Chevron",
  "block.minecraft.banner.triangle_bottom.orange": "Tawny Chevron",
  "block.minecraft.banner.triangle_bottom.pink": "Carnation Chevron",
  "block.minecraft.banner.triangle_bottom.purple": "Purple Chevron",
  "block.minecraft.banner.triangle_bottom.red": "Red Chevron",
  "block.minecraft.banner.triangle_bottom.white": "White Chevron",
  "block.minecraft.banner.triangle_bottom.yellow": "Yellow Chevron",
  "block.minecraft.banner.triangle_top.black": "Black Chevron Inverted",
  "block.minecraft.banner.triangle_top.blue": "Blue Chevron Inverted",
  "block.minecraft.banner.triangle_top.brown": "Brown Chevron Inverted",
  "block.minecraft.banner.triangle_top.cyan": "Turquoise Chevron Inverted",
  "block.minecraft.banner.triangle_top.gray": "Grey Chevron Inverted",
  "block.minecraft.banner.triangle_top.green": "Green Chevron Inverted",
  "block.minecraft.banner.triangle_top.light_blue": "Whey Chevron Inverted",
  "block.minecraft.banner.triangle_top.light_gray": "Pale Grey Chevron Inverted",
  "block.minecraft.banner.triangle_top.lime": "Lincoln Chevron Inverted",
  "block.minecraft.banner.triangle_top.magenta": "Mulberry Chevron Inverted",
  "block.minecraft.banner.triangle_top.orange": "Tawny Chevron Inverted",
  "block.minecraft.banner.triangle_top.pink": "Carnation Chevron Inverted",
  "block.minecraft.banner.triangle_top.purple": "Purple Chevron Inverted",
  "block.minecraft.banner.triangle_top.red": "Red Chevron Inverted",
  "block.minecraft.banner.triangle_top.white": "White Chevron Inverted",
  "block.minecraft.banner.triangle_top.yellow": "Yellow Chevron Inverted",
  "block.minecraft.banner.triangles_bottom.black": "Black Base Indented",
  "block.minecraft.banner.triangles_bottom.blue": "Blue Base Indented",
  "block.minecraft.banner.triangles_bottom.brown": "Brown Base Indented",
  "block.minecraft.banner.triangles_bottom.cyan": "Turquoise Base Indented",
  "block.minecraft.banner.triangles_bottom.gray": "Grey Base Indented",
  "block.minecraft.banner.triangles_bottom.green": "Green Base Indented",
  "block.minecraft.banner.triangles_bottom.light_blue": "Whey Base Indented",
  "block.minecraft.banner.triangles_bottom.light_gray": "Pale Grey Base Indented",
  "block.minecraft.banner.triangles_bottom.lime": "Lincoln Base Indented",
  "block.minecraft.banner.triangles_bottom.magenta": "Mulberry Base Indented",
  "block.minecraft.banner.triangles_bottom.orange": "Tawny Base Indented",
  "block.minecraft.banner.triangles_bottom.pink": "Carnation Base Indented",
  "block.minecraft.banner.triangles_bottom.purple": "Purple Base Indented",
  "block.minecraft.banner.triangles_bottom.red": "Red Base Indented",
  "block.minecraft.banner.triangles_bottom.white": "White Base Indented",
  "block.minecraft.banner.triangles_bottom.yellow": "Yellow Base Indented",
  "block.minecraft.banner.triangles_top.black": "Black Chief Indented",
  "block.minecraft.banner.triangles_top.blue": "Blue Chief Indented",
  "block.minecraft.banner.triangles_top.brown": "Brown Chief Indented",
  "block.minecraft.banner.triangles_top.cyan": "Turquoise Chief Indented",
  "block.minecraft.banner.triangles_top.gray": "Grey Chief Indented",
  "block.minecraft.banner.triangles_top.green": "Green Chief Indented",
  "block.minecraft.banner.triangles_top.light_blue": "Whey Chief Indented",
  "block.minecraft.banner.triangles_top.light_gray": "Pale Grey Chief Indented",
  "block.minecraft.banner.triangles_top.lime": "Lincoln Chief Indented",
  "block.minecraft.banner.triangles_top.magenta": "Mulberry Chief Indented",
  "block.minecraft.banner.triangles_top.orange": "Tawny Chief Indented",
  "block.minecraft.banner.triangles_top.pink": "Carnation Chief Indented",
  "block.minecraft.banner.triangles_top.purple": "Purple Chief Indented",
  "block.minecraft.banner.triangles_top.red": "Red Chief Indented",
  "block.minecraft.banner.triangles_top.white": "White Chief Indented",
  "block.minecraft.banner.triangles_top.yellow": "Yellow Chief Indented",
  "block.minecraft.barrel": "Barrel",
  "block.minecraft.barrier": "Closture",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Beacon",
  "block.minecraft.beacon.primary": "Dominant Power",
  "block.minecraft.beacon.secondary": "Secondary Power",
  "block.minecraft.bed.no_sleep": "Thou mayst sleep at times of night or tempest alone",
  "block.minecraft.bed.not_safe": "Thou cannot to bed, vouchsafe for creatures draw near",
  "block.minecraft.bed.obstructed": "Alas, an obstruct lies 'tween this bed and thou",
  "block.minecraft.bed.occupied": "Alas, some fellow slumbers thereon",
  "block.minecraft.bed.too_far_away": "Thou cannot to bed, yonder it lies",
  "block.minecraft.bedrock": "Touchstone",
  "block.minecraft.bee_nest": "Beehive",
  "block.minecraft.beehive": "Beehive",
  "block.minecraft.beetroots": "Beets",
  "block.minecraft.bell": "Bell",
  "block.minecraft.big_dripleaf": "Big Dripleaf",
  "block.minecraft.big_dripleaf_stem": "Big Dripleaf Stem",
  "block.minecraft.birch_button": "Birchen Button",
  "block.minecraft.birch_door": "Birchen Door",
  "block.minecraft.birch_fence": "Birchen Hedge",
  "block.minecraft.birch_fence_gate": "Birchen Hedge Gate",
  "block.minecraft.birch_hanging_sign": "Birchen Hung Sign",
  "block.minecraft.birch_leaves": "Birch Leaves",
  "block.minecraft.birch_log": "Birchen Log",
  "block.minecraft.birch_planks": "Birchen Timber",
  "block.minecraft.birch_pressure_plate": "Birchen Pressure Plate",
  "block.minecraft.birch_sapling": "Birch Sapling",
  "block.minecraft.birch_shelf": "Birchen Shelf",
  "block.minecraft.birch_sign": "Birchen Sign",
  "block.minecraft.birch_slab": "Birchen Slab",
  "block.minecraft.birch_stairs": "Birchen Stairs",
  "block.minecraft.birch_trapdoor": "Birchen Hatch",
  "block.minecraft.birch_wall_hanging_sign": "Birchen Hung Wallsign",
  "block.minecraft.birch_wall_sign": "Birchen Hung Sign",
  "block.minecraft.birch_wood": "Birchen Wood",
  "block.minecraft.black_banner": "Black Banner",
  "block.minecraft.black_bed": "Black Bed",
  "block.minecraft.black_candle": "Black Candle",
  "block.minecraft.black_candle_cake": "Black Candle upon a Cake",
  "block.minecraft.black_carpet": "Black Carpet",
  "block.minecraft.black_concrete": "Black Cement",
  "block.minecraft.black_concrete_powder": "Black Cement Powder",
  "block.minecraft.black_glazed_terracotta": "Black Porcelain",
  "block.minecraft.black_shulker_box": "Black Shulker Case",
  "block.minecraft.black_stained_glass": "Black-Coloured Glass",
  "block.minecraft.black_stained_glass_pane": "Black-Coloured Glass Pane",
  "block.minecraft.black_terracotta": "Black Earthen Block",
  "block.minecraft.black_wool": "Black Wool",
  "block.minecraft.blackstone": "Blackstone",
  "block.minecraft.blackstone_slab": "Blackstone Slab",
  "block.minecraft.blackstone_stairs": "Blackstone Stairs",
  "block.minecraft.blackstone_wall": "Blackstone Hedge",
  "block.minecraft.blast_furnace": "Forge",
  "block.minecraft.blue_banner": "Blue Banner",
  "block.minecraft.blue_bed": "Blue Bed",
  "block.minecraft.blue_candle": "Blue Candle",
  "block.minecraft.blue_candle_cake": "Blue Candle upon a Cake",
  "block.minecraft.blue_carpet": "Blue Carpet",
  "block.minecraft.blue_concrete": "Blue Cement",
  "block.minecraft.blue_concrete_powder": "Blue Cement Powder",
  "block.minecraft.blue_glazed_terracotta": "Blue Porcelain",
  "block.minecraft.blue_ice": "Blue Ice",
  "block.minecraft.blue_orchid": "Violets",
  "block.minecraft.blue_shulker_box": "Blue Shulker Case",
  "block.minecraft.blue_stained_glass": "Blue-coloured Glass",
  "block.minecraft.blue_stained_glass_pane": "Blue-Coloured Glass Pane",
  "block.minecraft.blue_terracotta": "Blue Earthen Block",
  "block.minecraft.blue_wool": "Blue Wool",
  "block.minecraft.bone_block": "Block of Bones",
  "block.minecraft.bookshelf": "Bookshelf",
  "block.minecraft.brain_coral": "Carnation Coral",
  "block.minecraft.brain_coral_block": "Block of Carnation Coral",
  "block.minecraft.brain_coral_fan": "Small Carnation Coral",
  "block.minecraft.brain_coral_wall_fan": "Small Hanging Carnation Coral",
  "block.minecraft.brewing_stand": "Alchemy Table",
  "block.minecraft.brick_slab": "Brick Slab",
  "block.minecraft.brick_stairs": "Brick Stairs",
  "block.minecraft.brick_wall": "Brick Hedge",
  "block.minecraft.bricks": "Bricks",
  "block.minecraft.brown_banner": "Brown Banner",
  "block.minecraft.brown_bed": "Brown Bed",
  "block.minecraft.brown_candle": "Brown Candle",
  "block.minecraft.brown_candle_cake": "Brown Candle upon a Cake",
  "block.minecraft.brown_carpet": "Brown Carpet",
  "block.minecraft.brown_concrete": "Brown Cement",
  "block.minecraft.brown_concrete_powder": "Brown Cement Powder",
  "block.minecraft.brown_glazed_terracotta": "Brown Porcelain",
  "block.minecraft.brown_mushroom": "Brown Mushroom",
  "block.minecraft.brown_mushroom_block": "Block of Brown Mushrooms",
  "block.minecraft.brown_shulker_box": "Brown Shulker Case",
  "block.minecraft.brown_stained_glass": "Brown-Coloured Glass",
  "block.minecraft.brown_stained_glass_pane": "Brown-Coloured Glass Pane",
  "block.minecraft.brown_terracotta": "Brown Earthen Block",
  "block.minecraft.brown_wool": "Brown Wool",
  "block.minecraft.bubble_column": "Pillar of Bubbles",
  "block.minecraft.bubble_coral": "Purple Coral",
  "block.minecraft.bubble_coral_block": "Block of Purple Coral",
  "block.minecraft.bubble_coral_fan": "Small Purple Coral",
  "block.minecraft.bubble_coral_wall_fan": "Small Hanging Purple Coral",
  "block.minecraft.budding_amethyst": "Budding Amethyst",
  "block.minecraft.bush": "Shrub",
  "block.minecraft.cactus": "Cactus",
  "block.minecraft.cactus_flower": "Cactus Flower",
  "block.minecraft.cake": "Cake",
  "block.minecraft.calcite": "Calcite",
  "block.minecraft.calibrated_sculk_sensor": "Calibrat'd Sculk Sens'r",
  "block.minecraft.campfire": "Camp fire",
  "block.minecraft.candle": "Candle",
  "block.minecraft.candle_cake": "Candle Cake",
  "block.minecraft.carrots": "Carets",
  "block.minecraft.cartography_table": "Mappery Table",
  "block.minecraft.carved_pumpkin": "Carved Pumpion",
  "block.minecraft.cauldron": "Cauldron",
  "block.minecraft.cave_air": "Cave Air",
  "block.minecraft.cave_vines": "Cavern Vines",
  "block.minecraft.cave_vines_plant": "Cavern Vines Plant",
  "block.minecraft.chain": "Iron Chain",
  "block.minecraft.chain_command_block": "Chain Command Block",
  "block.minecraft.cherry_button": "Cherry Button",
  "block.minecraft.cherry_door": "Cherry Door",
  "block.minecraft.cherry_fence": "Cherry Hedge",
  "block.minecraft.cherry_fence_gate": "Cherry Hedge Gate",
  "block.minecraft.cherry_hanging_sign": "Cherry Hung Sign",
  "block.minecraft.cherry_leaves": "Cherry Leaves",
  "block.minecraft.cherry_log": "Cherry Log",
  "block.minecraft.cherry_planks": "Cherry Timber",
  "block.minecraft.cherry_pressure_plate": "Cherry Pressure Plate",
  "block.minecraft.cherry_sapling": "Cherry Sapling",
  "block.minecraft.cherry_shelf": "Cherry Shelf",
  "block.minecraft.cherry_sign": "Cherry Sign",
  "block.minecraft.cherry_slab": "Cherry Slab",
  "block.minecraft.cherry_stairs": "Cherry Stairs",
  "block.minecraft.cherry_trapdoor": "Cherry Hatch",
  "block.minecraft.cherry_wall_hanging_sign": "Cherry Hung Wallsign",
  "block.minecraft.cherry_wall_sign": "Cherry Hung Sign",
  "block.minecraft.cherry_wood": "Cherry Wood",
  "block.minecraft.chest": "Chest",
  "block.minecraft.chipped_anvil": "Crack'd Anvil",
  "block.minecraft.chiseled_bookshelf": "Chisel'd Bookshelf",
  "block.minecraft.chiseled_copper": "Chisel'd Copper",
  "block.minecraft.chiseled_deepslate": "Chisel'd Deepethslate",
  "block.minecraft.chiseled_nether_bricks": "Chisel'd Nether Bricks",
  "block.minecraft.chiseled_polished_blackstone": "Chisel'd Polish'd Blackstone",
  "block.minecraft.chiseled_quartz_block": "Chisel'd Block of Quarz",
  "block.minecraft.chiseled_red_sandstone": "Chisel'd Red Sandstone",
  "block.minecraft.chiseled_resin_bricks": "Chisel'd Hardened Sap Bricks",
  "block.minecraft.chiseled_sandstone": "Graven Sandstone",
  "block.minecraft.chiseled_stone_bricks": "Chisel'd Stone Bricks",
  "block.minecraft.chiseled_tuff": "Chisel'd Tuff",
  "block.minecraft.chiseled_tuff_bricks": "Chisel'd tuff bricks",
  "block.minecraft.chorus_flower": "Chorus Flower",
  "block.minecraft.chorus_plant": "Chorus Plant",
  "block.minecraft.clay": "Clay",
  "block.minecraft.closed_eyeblossom": "Closed Eyeblossom",
  "block.minecraft.coal_block": "Block of Coal",
  "block.minecraft.coal_ore": "Coal Ore",
  "block.minecraft.coarse_dirt": "Coarse Dirt",
  "block.minecraft.cobbled_deepslate": "Cobbl'd Deepethslate",
  "block.minecraft.cobbled_deepslate_slab": "Cobbl'd Deepethslate Slab",
  "block.minecraft.cobbled_deepslate_stairs": "Cobbl'd Deepethslate Stairs",
  "block.minecraft.cobbled_deepslate_wall": "Cobbl'd Deepethslate Hedge",
  "block.minecraft.cobblestone": "Cobble",
  "block.minecraft.cobblestone_slab": "Cobble Slab",
  "block.minecraft.cobblestone_stairs": "Cobble Stairs",
  "block.minecraft.cobblestone_wall": "Cobble Hedge",
  "block.minecraft.cobweb": "Cobweb",
  "block.minecraft.cocoa": "Cacao",
  "block.minecraft.command_block": "Command Block",
  "block.minecraft.comparator": "Redstone Metre",
  "block.minecraft.composter": "Composter",
  "block.minecraft.conduit": "Conduit",
  "block.minecraft.copper_bars": "Coppern Bars",
  "block.minecraft.copper_block": "Block of Copp'r",
  "block.minecraft.copper_bulb": "Copp'r Bulb",
  "block.minecraft.copper_chain": "Coppern Chain",
  "block.minecraft.copper_chest": "Coppern Chest",
  "block.minecraft.copper_door": "Coppern Door",
  "block.minecraft.copper_golem_statue": "Coppern Homunculus Statue",
  "block.minecraft.copper_grate": "Coppern Grate",
  "block.minecraft.copper_lantern": "Coppern Lantern",
  "block.minecraft.copper_ore": "Copp'r Ore",
  "block.minecraft.copper_torch": "Coppern Torch",
  "block.minecraft.copper_trapdoor": "Coppern Hatch",
  "block.minecraft.copper_wall_torch": "Coppern Wall Torch",
  "block.minecraft.cornflower": "Pansy",
  "block.minecraft.cracked_deepslate_bricks": "Crack'd Deepethslate Bricks",
  "block.minecraft.cracked_deepslate_tiles": "Crack'd Deepethslate Tyles",
  "block.minecraft.cracked_nether_bricks": "Crack'd Nether Bricks",
  "block.minecraft.cracked_polished_blackstone_bricks": "Crack'd Polish'd Blackstone Bricks",
  "block.minecraft.cracked_stone_bricks": "Crack'd Stone Bricks",
  "block.minecraft.crafter": "Fabricator",
  "block.minecraft.crafting_table": "Crafts Table",
  "block.minecraft.creaking_heart": "Heart that Doth Creak",
  "block.minecraft.creeper_head": "Creeper Head",
  "block.minecraft.creeper_wall_head": "Hung Creeper Head",
  "block.minecraft.crimson_button": "Crimsonwood Button",
  "block.minecraft.crimson_door": "Crimsonwood Door",
  "block.minecraft.crimson_fence": "Crimsonwood Hedge",
  "block.minecraft.crimson_fence_gate": "Crimsonwood Hedge Gate",
  "block.minecraft.crimson_fungus": "Crimson Mushrump",
  "block.minecraft.crimson_hanging_sign": "Crimsonwood Hung Sign",
  "block.minecraft.crimson_hyphae": "Crimson Hyphæ",
  "block.minecraft.crimson_nylium": "Crimson Nylium",
  "block.minecraft.crimson_planks": "Crimsonwood Planks",
  "block.minecraft.crimson_pressure_plate": "Crimsonwood Pressure Plate",
  "block.minecraft.crimson_roots": "Crimson Rootes",
  "block.minecraft.crimson_shelf": "Crimsonwood Shelf",
  "block.minecraft.crimson_sign": "Crimsonwood Sign",
  "block.minecraft.crimson_slab": "Crimsonwood Slab",
  "block.minecraft.crimson_stairs": "Crimsonwood Stairs",
  "block.minecraft.crimson_stem": "Crimson Stem",
  "block.minecraft.crimson_trapdoor": "Crimsonwood Hatch",
  "block.minecraft.crimson_wall_hanging_sign": "Crimsonwood Hung Wallsign",
  "block.minecraft.crimson_wall_sign": "Crimsonwood Wallsign",
  "block.minecraft.crying_obsidian": "Crying Obsidian",
  "block.minecraft.cut_copper": "Cutten Copper",
  "block.minecraft.cut_copper_slab": "Cutten Coppern Slab",
  "block.minecraft.cut_copper_stairs": "Cutten Copper Stair",
  "block.minecraft.cut_red_sandstone": "Cut Red Sandstone",
  "block.minecraft.cut_red_sandstone_slab": "Cut Red Sandstone Slab",
  "block.minecraft.cut_sandstone": "Cut Sandstone",
  "block.minecraft.cut_sandstone_slab": "Cut Sandstone Slab",
  "block.minecraft.cyan_banner": "Turquoise Banner",
  "block.minecraft.cyan_bed": "Turquoise Bed",
  "block.minecraft.cyan_candle": "Turquoise Candle",
  "block.minecraft.cyan_candle_cake": "Cyan Candle upon a Cake",
  "block.minecraft.cyan_carpet": "Turquoise Carpet",
  "block.minecraft.cyan_concrete": "Turquoise Cement",
  "block.minecraft.cyan_concrete_powder": "Turquoise Cement Powder",
  "block.minecraft.cyan_glazed_terracotta": "Turquoise Porcelain",
  "block.minecraft.cyan_shulker_box": "Turquoise Shulker Case",
  "block.minecraft.cyan_stained_glass": "Turquoise-Coloured Glass",
  "block.minecraft.cyan_stained_glass_pane": "Turquoise-Coloured Glass Pane",
  "block.minecraft.cyan_terracotta": "Turquoise Earthen Block",
  "block.minecraft.cyan_wool": "Turquoise Wool",
  "block.minecraft.damaged_anvil": "Fracted Anvil",
  "block.minecraft.dandelion": "Daffodil",
  "block.minecraft.dark_oak_button": "Ebon Button",
  "block.minecraft.dark_oak_door": "Ebon Door",
  "block.minecraft.dark_oak_fence": "Ebony Hedge",
  "block.minecraft.dark_oak_fence_gate": "Ebony Hedge Gate",
  "block.minecraft.dark_oak_hanging_sign": "Ebon Hung Sign",
  "block.minecraft.dark_oak_leaves": "Ebon Leaves",
  "block.minecraft.dark_oak_log": "Ebon Log",
  "block.minecraft.dark_oak_planks": "Ebon Timber",
  "block.minecraft.dark_oak_pressure_plate": "Ebon Pressure Plate",
  "block.minecraft.dark_oak_sapling": "Ebon Sapling",
  "block.minecraft.dark_oak_shelf": "Ebon Shelf",
  "block.minecraft.dark_oak_sign": "Ebon Sign",
  "block.minecraft.dark_oak_slab": "Ebon Slab",
  "block.minecraft.dark_oak_stairs": "Ebon Stairs",
  "block.minecraft.dark_oak_trapdoor": "Ebon Hatch",
  "block.minecraft.dark_oak_wall_hanging_sign": "Ebon Hung Wallsign",
  "block.minecraft.dark_oak_wall_sign": "Ebon Hung Sign",
  "block.minecraft.dark_oak_wood": "Ebony Log",
  "block.minecraft.dark_prismarine": "Dark Prismarine",
  "block.minecraft.dark_prismarine_slab": "Dark Prismarine Slab",
  "block.minecraft.dark_prismarine_stairs": "Dark Prismarine Stairs",
  "block.minecraft.daylight_detector": "Sun Watcher",
  "block.minecraft.dead_brain_coral": "Dead Carnation Coral",
  "block.minecraft.dead_brain_coral_block": "Block of Dead Carnation Coral",
  "block.minecraft.dead_brain_coral_fan": "Dead Small Carnation Coral",
  "block.minecraft.dead_brain_coral_wall_fan": "Dead Small Hanging Carnation Coral",
  "block.minecraft.dead_bubble_coral": "Dead Purple Coral",
  "block.minecraft.dead_bubble_coral_block": "Block of Dead Purple Coral",
  "block.minecraft.dead_bubble_coral_fan": "Dead Small Purple Coral",
  "block.minecraft.dead_bubble_coral_wall_fan": "Dead Small Hanging Purple Coral",
  "block.minecraft.dead_bush": "Wither'd Shrub",
  "block.minecraft.dead_fire_coral": "Dead Red Coral",
  "block.minecraft.dead_fire_coral_block": "Block of Dead Red Coral",
  "block.minecraft.dead_fire_coral_fan": "Dead Small Red Coral",
  "block.minecraft.dead_fire_coral_wall_fan": "Dead Small Hanging Red Coral",
  "block.minecraft.dead_horn_coral": "Dead Yellow Coral",
  "block.minecraft.dead_horn_coral_block": "Block of Dead Yellow Coral",
  "block.minecraft.dead_horn_coral_fan": "Dead Small Yellow Coral",
  "block.minecraft.dead_horn_coral_wall_fan": "Dead Small Hanging Yellow Coral",
  "block.minecraft.dead_tube_coral": "Dead Blue Coral",
  "block.minecraft.dead_tube_coral_block": "Block of Dead Blue Coral",
  "block.minecraft.dead_tube_coral_fan": "Dead Small Blue Coral",
  "block.minecraft.dead_tube_coral_wall_fan": "Dead Small Hanging Blue Coral",
  "block.minecraft.decorated_pot": "Embellished Pot",
  "block.minecraft.deepslate": "Deepethslate",
  "block.minecraft.deepslate_brick_slab": "Deepethslate Brick Slab",
  "block.minecraft.deepslate_brick_stairs": "Deepethslate Brick Stairs",
  "block.minecraft.deepslate_brick_wall": "Deepethslate Brick Hedge",
  "block.minecraft.deepslate_bricks": "Deepethslate Bricks",
  "block.minecraft.deepslate_coal_ore": "Deepethslate Coal Ore",
  "block.minecraft.deepslate_copper_ore": "Deepethslate Copp'r Ore",
  "block.minecraft.deepslate_diamond_ore": "Deepethslate Diamond Ore",
  "block.minecraft.deepslate_emerald_ore": "Deepethslate Emerald Ore",
  "block.minecraft.deepslate_gold_ore": "Deepethslate Gold Ore",
  "block.minecraft.deepslate_iron_ore": "Deepethslate Iron Ore",
  "block.minecraft.deepslate_lapis_ore": "Deepethslate Lapis Ore",
  "block.minecraft.deepslate_redstone_ore": "Deepethslate Redstone Ore",
  "block.minecraft.deepslate_tile_slab": "Deepethslate Tyle Slab",
  "block.minecraft.deepslate_tile_stairs": "Deepethslate Tyle Stairs",
  "block.minecraft.deepslate_tile_wall": "Deepethslate Tyle Hedge",
  "block.minecraft.deepslate_tiles": "Deepethslate Tyles",
  "block.minecraft.detector_rail": "Sensing Iron-Rut",
  "block.minecraft.diamond_block": "Block of Diamond",
  "block.minecraft.diamond_ore": "Diamond Ore",
  "block.minecraft.diorite": "Limestone",
  "block.minecraft.diorite_slab": "Limestone Slab",
  "block.minecraft.diorite_stairs": "Limestone Stairs",
  "block.minecraft.diorite_wall": "Limestone Hedge",
  "block.minecraft.dirt": "Dirt",
  "block.minecraft.dirt_path": "Path of Loose Soil",
  "block.minecraft.dispenser": "Dispenser",
  "block.minecraft.dragon_egg": "Dragon Egg",
  "block.minecraft.dragon_head": "Dragon Head",
  "block.minecraft.dragon_wall_head": "Hung Dragon Head",
  "block.minecraft.dried_ghast": "Dried Ghast",
  "block.minecraft.dried_kelp_block": "Block of Dried Seaweed",
  "block.minecraft.dripstone_block": "Block of Dripstone",
  "block.minecraft.dropper": "Dropper",
  "block.minecraft.emerald_block": "Block of Emerald",
  "block.minecraft.emerald_ore": "Emerald Ore",
  "block.minecraft.enchanting_table": "Table of Witchcrafts",
  "block.minecraft.end_gateway": "End Entrance",
  "block.minecraft.end_portal": "End Portal",
  "block.minecraft.end_portal_frame": "End Portal Frame",
  "block.minecraft.end_rod": "End Rod",
  "block.minecraft.end_stone": "End Stone",
  "block.minecraft.end_stone_brick_slab": "End Stone Brick Slab",
  "block.minecraft.end_stone_brick_stairs": "End Stone Brick Stairs",
  "block.minecraft.end_stone_brick_wall": "End Stone Brick Hedge",
  "block.minecraft.end_stone_bricks": "End Stone Bricks",
  "block.minecraft.ender_chest": "Ender Chest",
  "block.minecraft.exposed_chiseled_copper": "Tarnished Chiseled Copper",
  "block.minecraft.exposed_copper": "Expos'd Copp'r",
  "block.minecraft.exposed_copper_bars": "Tarnished Coppern Bars",
  "block.minecraft.exposed_copper_bulb": "Tarnished Coppern Bulb",
  "block.minecraft.exposed_copper_chain": "Tarnished Coppern Chain",
  "block.minecraft.exposed_copper_chest": "Tarnished Coppern Chest",
  "block.minecraft.exposed_copper_door": "Tarnished Coppern Door",
  "block.minecraft.exposed_copper_golem_statue": "Tarnished Coppern Homunculus Statue",
  "block.minecraft.exposed_copper_grate": "Tarnished Coppern Grate",
  "block.minecraft.exposed_copper_lantern": "Tarnished Coppern Lantern",
  "block.minecraft.exposed_copper_trapdoor": "Tarnished Coppern Hatch",
  "block.minecraft.exposed_cut_copper": "Tarnished Cutten Copper",
  "block.minecraft.exposed_cut_copper_slab": "Tarnished Cutten Copper Slab",
  "block.minecraft.exposed_cut_copper_stairs": "Tarnished Cutten Copper Stairs",
  "block.minecraft.exposed_lightning_rod": "The Unveiled Rod, That Doth Summon Thunder's Wrath",
  "block.minecraft.farmland": "Ploughed Dirt",
  "block.minecraft.fern": "Fern",
  "block.minecraft.fire": "Fire",
  "block.minecraft.fire_coral": "Red Coral",
  "block.minecraft.fire_coral_block": "Red Coral Block",
  "block.minecraft.fire_coral_fan": "Small Red Coral",
  "block.minecraft.fire_coral_wall_fan": "Small Hanging Red Coral",
  "block.minecraft.firefly_bush": "Fairy Shrub",
  "block.minecraft.fletching_table": "Fletching Table",
  "block.minecraft.flower_pot": "Flower Pot",
  "block.minecraft.flowering_azalea": "Flowering Shrub",
  "block.minecraft.flowering_azalea_leaves": "Flowering Shrub Leaves",
  "block.minecraft.frogspawn": "Frogspawn",
  "block.minecraft.frosted_ice": "Frost'd Ice",
  "block.minecraft.furnace": "Furnace",
  "block.minecraft.gilded_blackstone": "Gilded Blackstone",
  "block.minecraft.glass": "Glass",
  "block.minecraft.glass_pane": "Glass Pane",
  "block.minecraft.glow_lichen": "Glowen Lich'n",
  "block.minecraft.glowstone": "Glowstone",
  "block.minecraft.gold_block": "Block of Gold",
  "block.minecraft.gold_ore": "Gold Ore",
  "block.minecraft.golden_dandelion": "Gilded Daffodil",
  "block.minecraft.granite": "Red Grainstone",
  "block.minecraft.granite_slab": "Red Grainstone Slab",
  "block.minecraft.granite_stairs": "Red Grainstone Stairs",
  "block.minecraft.granite_wall": "Red Grainstone Hedge",
  "block.minecraft.grass": "Grass",
  "block.minecraft.grass_block": "Block of Grassy Dirt",
  "block.minecraft.gravel": "Gravel",
  "block.minecraft.gray_banner": "Grey Banner",
  "block.minecraft.gray_bed": "Grey Bed",
  "block.minecraft.gray_candle": "Grey Candle",
  "block.minecraft.gray_candle_cake": "Grey Candle upon a Cake",
  "block.minecraft.gray_carpet": "Grey Carpet",
  "block.minecraft.gray_concrete": "Grey Cement",
  "block.minecraft.gray_concrete_powder": "Grey Cement Powder",
  "block.minecraft.gray_glazed_terracotta": "Grey Porcelain",
  "block.minecraft.gray_shulker_box": "Grey Shulker Case",
  "block.minecraft.gray_stained_glass": "Grey-Coloured Glass",
  "block.minecraft.gray_stained_glass_pane": "Grey-Coloured Glass Pane",
  "block.minecraft.gray_terracotta": "Grey Earthen Block",
  "block.minecraft.gray_wool": "Grey Wool",
  "block.minecraft.green_banner": "Green Banner",
  "block.minecraft.green_bed": "Green Bed",
  "block.minecraft.green_candle": "Green Candle",
  "block.minecraft.green_candle_cake": "Green Candle upon a Cake",
  "block.minecraft.green_carpet": "Green Carpet",
  "block.minecraft.green_concrete": "Green Cement",
  "block.minecraft.green_concrete_powder": "Green Cement Powder",
  "block.minecraft.green_glazed_terracotta": "Green Porcelain",
  "block.minecraft.green_shulker_box": "Green Shulker Case",
  "block.minecraft.green_stained_glass": "Green-Coloured Glass",
  "block.minecraft.green_stained_glass_pane": "Green-Coloured Glass Pane",
  "block.minecraft.green_terracotta": "Green Earthen Block",
  "block.minecraft.green_wool": "Green Wool",
  "block.minecraft.grindstone": "Grindstone",
  "block.minecraft.hanging_roots": "Hanging Rootes",
  "block.minecraft.hay_block": "Bottle of Hay",
  "block.minecraft.heavy_core": "Weighty Heart",
  "block.minecraft.heavy_weighted_pressure_plate": "Heavy Pressure Plate",
  "block.minecraft.honey_block": "Honey Block",
  "block.minecraft.honeycomb_block": "Honeycomb block",
  "block.minecraft.hopper": "Conveyer",
  "block.minecraft.horn_coral": "Yellow Coral",
  "block.minecraft.horn_coral_block": "Yellow Coral Block",
  "block.minecraft.horn_coral_fan": "Small Yellow Coral",
  "block.minecraft.horn_coral_wall_fan": "Small Hanging Yellow Coral",
  "block.minecraft.ice": "Ice",
  "block.minecraft.infested_chiseled_stone_bricks": "Infested Chisel'd Stone Bricks",
  "block.minecraft.infested_cobblestone": "Infested Cobble",
  "block.minecraft.infested_cracked_stone_bricks": "Infested Crack'd Bricks",
  "block.minecraft.infested_deepslate": "Infested Deepethslate",
  "block.minecraft.infested_mossy_stone_bricks": "Infested Moss'd Bricks",
  "block.minecraft.infested_stone": "Infested Stone",
  "block.minecraft.infested_stone_bricks": "Infested Bricks",
  "block.minecraft.iron_bars": "Iron Bars",
  "block.minecraft.iron_block": "Block of Iron",
  "block.minecraft.iron_chain": "Links of Iron",
  "block.minecraft.iron_door": "Iron Door",
  "block.minecraft.iron_ore": "Iron Ore",
  "block.minecraft.iron_trapdoor": "Iron Hatch",
  "block.minecraft.jack_o_lantern": "Jack o'Lantern",
  "block.minecraft.jigsaw": "Unfolding Block",
  "block.minecraft.jukebox": "Music Box",
  "block.minecraft.jungle_button": "Exotic Button",
  "block.minecraft.jungle_door": "Exotic Door",
  "block.minecraft.jungle_fence": "Exotic Wood Hedge",
  "block.minecraft.jungle_fence_gate": "Exotic Hedge Gate",
  "block.minecraft.jungle_hanging_sign": "Exotic Hung Sign",
  "block.minecraft.jungle_leaves": "Exotic Leaves",
  "block.minecraft.jungle_log": "Exotic Log",
  "block.minecraft.jungle_planks": "Exotic Timber",
  "block.minecraft.jungle_pressure_plate": "Exotic Pressure Plate",
  "block.minecraft.jungle_sapling": "Exotic Sapling",
  "block.minecraft.jungle_shelf": "Exotic Shelf",
  "block.minecraft.jungle_sign": "Exotic Sign",
  "block.minecraft.jungle_slab": "Exotic Slab",
  "block.minecraft.jungle_stairs": "Exotic Stairs",
  "block.minecraft.jungle_trapdoor": "Exotic Hatch",
  "block.minecraft.jungle_wall_hanging_sign": "Exotic Hung Wallsign",
  "block.minecraft.jungle_wall_sign": "Exotic Hung Sign",
  "block.minecraft.jungle_wood": "Exotic Log",
  "block.minecraft.kelp": "Seaweed",
  "block.minecraft.kelp_plant": "Seaweed Plant",
  "block.minecraft.ladder": "Ladder",
  "block.minecraft.lantern": "Lantern",
  "block.minecraft.lapis_block": "Block of Lapis",
  "block.minecraft.lapis_ore": "Lapis Ore",
  "block.minecraft.large_amethyst_bud": "Large Amethyst Bud",
  "block.minecraft.large_fern": "Large Fern",
  "block.minecraft.lava": "Molten Stone",
  "block.minecraft.lava_cauldron": "Casket of Molten Stone",
  "block.minecraft.leaf_litter": "Leaf Rubbish",
  "block.minecraft.lectern": "Lectern",
  "block.minecraft.lever": "Lever",
  "block.minecraft.light": "Illumination",
  "block.minecraft.light_blue_banner": "Whey Banner",
  "block.minecraft.light_blue_bed": "Whey Bed",
  "block.minecraft.light_blue_candle": "Whey Candle",
  "block.minecraft.light_blue_candle_cake": "Whey Candle upon a Cake",
  "block.minecraft.light_blue_carpet": "Whey Carpet",
  "block.minecraft.light_blue_concrete": "Whey Cement",
  "block.minecraft.light_blue_concrete_powder": "Whey Cement Powder",
  "block.minecraft.light_blue_glazed_terracotta": "Whey Porcelain",
  "block.minecraft.light_blue_shulker_box": "Whey Shulker Case",
  "block.minecraft.light_blue_stained_glass": "Whey-coloured Glass",
  "block.minecraft.light_blue_stained_glass_pane": "Whey-Coloured Glass Pane",
  "block.minecraft.light_blue_terracotta": "Whey Earthen Block",
  "block.minecraft.light_blue_wool": "Whey Wool",
  "block.minecraft.light_gray_banner": "Pale Grey Banner",
  "block.minecraft.light_gray_bed": "Pale Grey Bed",
  "block.minecraft.light_gray_candle": "Pale Grey Candle",
  "block.minecraft.light_gray_candle_cake": "Pale Grey Candle upon a Cake",
  "block.minecraft.light_gray_carpet": "Pale Grey Carpet",
  "block.minecraft.light_gray_concrete": "Pale Grey Cement",
  "block.minecraft.light_gray_concrete_powder": "Pale Grey Cement Powder",
  "block.minecraft.light_gray_glazed_terracotta": "Pale Grey Porcelain",
  "block.minecraft.light_gray_shulker_box": "Pale Grey Shulker Case",
  "block.minecraft.light_gray_stained_glass": "Pale Grey-Coloured Glass",
  "block.minecraft.light_gray_stained_glass_pane": "Pale Grey-Coloured Glass Pane",
  "block.minecraft.light_gray_terracotta": "Pale Grey Earthen Block",
  "block.minecraft.light_gray_wool": "Pale Grey Wool",
  "block.minecraft.light_weighted_pressure_plate": "Light Pressure Plate",
  "block.minecraft.lightning_rod": "Lightning Rod",
  "block.minecraft.lilac": "Gillyvor",
  "block.minecraft.lily_of_the_valley": "Lily of the Valley",
  "block.minecraft.lily_pad": "Water-Lily",
  "block.minecraft.lime_banner": "Lincoln Banner",
  "block.minecraft.lime_bed": "Lincoln Bed",
  "block.minecraft.lime_candle": "Lincoln Candle",
  "block.minecraft.lime_candle_cake": "Lime Candle upon a Cake",
  "block.minecraft.lime_carpet": "Lincoln Carpet",
  "block.minecraft.lime_concrete": "Lincoln Cement",
  "block.minecraft.lime_concrete_powder": "Lincoln Cement Powder",
  "block.minecraft.lime_glazed_terracotta": "Lincoln Porcelain",
  "block.minecraft.lime_shulker_box": "Lincoln Shulker Case",
  "block.minecraft.lime_stained_glass": "Lincoln-Coloured Glass",
  "block.minecraft.lime_stained_glass_pane": "Lincoln-Coloured Glass Pane",
  "block.minecraft.lime_terracotta": "Lincoln Earthen Block",
  "block.minecraft.lime_wool": "Lincoln Wool",
  "block.minecraft.lodestone": "Lodestone",
  "block.minecraft.loom": "Loom",
  "block.minecraft.magenta_banner": "Mulberry Banner",
  "block.minecraft.magenta_bed": "Mulberry Bed",
  "block.minecraft.magenta_candle": "Mulberry Candle",
  "block.minecraft.magenta_candle_cake": "Magenta Candle upon a Cake",
  "block.minecraft.magenta_carpet": "Mulberry Carpet",
  "block.minecraft.magenta_concrete": "Mulberry Cement",
  "block.minecraft.magenta_concrete_powder": "Mulberry Cement Powder",
  "block.minecraft.magenta_glazed_terracotta": "Mulberry Porcelain",
  "block.minecraft.magenta_shulker_box": "Mulberry Shulker Case",
  "block.minecraft.magenta_stained_glass": "Mulberry-coloured Glass",
  "block.minecraft.magenta_stained_glass_pane": "Mulberry-Coloured Glass Pane",
  "block.minecraft.magenta_terracotta": "Mulberry Earthen Block",
  "block.minecraft.magenta_wool": "Mulberry Wool",
  "block.minecraft.magma_block": "Block of Burning Stone",
  "block.minecraft.mangrove_button": "Marsh Button",
  "block.minecraft.mangrove_door": "Marsh Door",
  "block.minecraft.mangrove_fence": "Marsh Hedge",
  "block.minecraft.mangrove_fence_gate": "Marsh Hedge Gate",
  "block.minecraft.mangrove_hanging_sign": "Marsh Hung Sign",
  "block.minecraft.mangrove_leaves": "Marsh Leaves",
  "block.minecraft.mangrove_log": "Marsh Log",
  "block.minecraft.mangrove_planks": "Marsh Timber",
  "block.minecraft.mangrove_pressure_plate": "Marsh Pressure Plate",
  "block.minecraft.mangrove_propagule": "Marsh Bud",
  "block.minecraft.mangrove_roots": "Marsh Roots",
  "block.minecraft.mangrove_shelf": "Marsh Shelf",
  "block.minecraft.mangrove_sign": "Marsh Sign",
  "block.minecraft.mangrove_slab": "Marsh Slab",
  "block.minecraft.mangrove_stairs": "Marsh Stairs",
  "block.minecraft.mangrove_trapdoor": "Marsh Hatch",
  "block.minecraft.mangrove_wall_hanging_sign": "Marsh Hung Wallsign",
  "block.minecraft.mangrove_wall_sign": "Marsh Hung Sign",
  "block.minecraft.mangrove_wood": "Marsh Wood",
  "block.minecraft.medium_amethyst_bud": "Medium Amethyst Bud",
  "block.minecraft.melon": "Melon",
  "block.minecraft.melon_stem": "Melon Stem",
  "block.minecraft.moss_block": "Moss Block",
  "block.minecraft.moss_carpet": "Moss Carpet",
  "block.minecraft.mossy_cobblestone": "Moss'd Cobble",
  "block.minecraft.mossy_cobblestone_slab": "Moss'd Cobble Slab",
  "block.minecraft.mossy_cobblestone_stairs": "Moss'd Cobble Stairs",
  "block.minecraft.mossy_cobblestone_wall": "Moss'd Cobble Hedge",
  "block.minecraft.mossy_stone_brick_slab": "Moss'd Stone Brick Slab",
  "block.minecraft.mossy_stone_brick_stairs": "Moss'd Stone Brick Stairs",
  "block.minecraft.mossy_stone_brick_wall": "Moss'd Stone Brick Hedge",
  "block.minecraft.mossy_stone_bricks": "Moss'd Stone Bricks",
  "block.minecraft.moving_piston": "Moving Extender",
  "block.minecraft.mud": "Mud",
  "block.minecraft.mud_brick_slab": "Mud Brick Slab",
  "block.minecraft.mud_brick_stairs": "Mud Brick Stairs",
  "block.minecraft.mud_brick_wall": "Mud Brick Hedge",
  "block.minecraft.mud_bricks": "Mud Bricks",
  "block.minecraft.muddy_mangrove_roots": "Muddy Marsh Roots",
  "block.minecraft.mushroom_stem": "Mushroom Stem",
  "block.minecraft.mycelium": "Mouldy Dirt",
  "block.minecraft.nether_brick_fence": "Small Nether Brick Hedge",
  "block.minecraft.nether_brick_slab": "Nether Brick Slab",
  "block.minecraft.nether_brick_stairs": "Nether Brick Stairs",
  "block.minecraft.nether_brick_wall": "Nether Brick Hedge",
  "block.minecraft.nether_bricks": "Nether Bricks",
  "block.minecraft.nether_gold_ore": "Nether Gold Ore",
  "block.minecraft.nether_portal": "Nether Portal",
  "block.minecraft.nether_quartz_ore": "Nether Quarz Ore",
  "block.minecraft.nether_sprouts": "Nether Sprouts",
  "block.minecraft.nether_wart": "Nether Wart",
  "block.minecraft.nether_wart_block": "Block of Nether Wart",
  "block.minecraft.netherite_block": "Block of Netherite",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Note Block",
  "block.minecraft.oak_button": "Oaken Button",
  "block.minecraft.oak_door": "Oaken Door",
  "block.minecraft.oak_fence": "Oaken Hedge",
  "block.minecraft.oak_fence_gate": "Oaken Hedge Gate",
  "block.minecraft.oak_hanging_sign": "Oaken Hung Sign",
  "block.minecraft.oak_leaves": "Oak Leaves",
  "block.minecraft.oak_log": "Oaken Log",
  "block.minecraft.oak_planks": "Oaken Timber",
  "block.minecraft.oak_pressure_plate": "Oaken Pressure Plate",
  "block.minecraft.oak_sapling": "Oak Sapling",
  "block.minecraft.oak_shelf": "Oaken Shelf",
  "block.minecraft.oak_sign": "Oaken Sign",
  "block.minecraft.oak_slab": "Oaken Slab",
  "block.minecraft.oak_stairs": "Oaken Stairs",
  "block.minecraft.oak_trapdoor": "Oaken Hatch",
  "block.minecraft.oak_wall_hanging_sign": "Oaken Hung Wallsign",
  "block.minecraft.oak_wall_sign": "Oaken Hung Sign",
  "block.minecraft.oak_wood": "Oaken Log",
  "block.minecraft.observer": "Watcher",
  "block.minecraft.obsidian": "Obsidian",
  "block.minecraft.ochre_froglight": "Ochre Froglight",
  "block.minecraft.ominous_banner": "Ominous Banner",
  "block.minecraft.open_eyeblossom": "Open Flower Of The All-Seeing",
  "block.minecraft.orange_banner": "Tawny Banner",
  "block.minecraft.orange_bed": "Tawny Bed",
  "block.minecraft.orange_candle": "Tawny Candle",
  "block.minecraft.orange_candle_cake": "Tawny Candle upon a Cake",
  "block.minecraft.orange_carpet": "Tawny Carpet",
  "block.minecraft.orange_concrete": "Tawny Cement",
  "block.minecraft.orange_concrete_powder": "Tawny Cement Powder",
  "block.minecraft.orange_glazed_terracotta": "Tawny Porcelain",
  "block.minecraft.orange_shulker_box": "Tawny Shulker Case",
  "block.minecraft.orange_stained_glass": "Tawny-Coloured Glass",
  "block.minecraft.orange_stained_glass_pane": "Tawny-Coloured Glass Pane",
  "block.minecraft.orange_terracotta": "Tawny Earthen Block",
  "block.minecraft.orange_tulip": "Tawny Carnation",
  "block.minecraft.orange_wool": "Tawny Wool",
  "block.minecraft.oxeye_daisy": "Daisy",
  "block.minecraft.oxidized_chiseled_copper": "Verdigris Chiseled Copper",
  "block.minecraft.oxidized_copper": "Oxidis'd Copp'r",
  "block.minecraft.oxidized_copper_bars": "Verdigris Coppern Bars",
  "block.minecraft.oxidized_copper_bulb": "Verdigris Coppern Bulb",
  "block.minecraft.oxidized_copper_chain": "Verdigris Coppern Chain",
  "block.minecraft.oxidized_copper_chest": "Verdigris Coppern Chest",
  "block.minecraft.oxidized_copper_door": "Verdigris Coppern Door",
  "block.minecraft.oxidized_copper_golem_statue": "Verdigris Coppern Homunculus Statue",
  "block.minecraft.oxidized_copper_grate": "Verdigris Coppern Grate",
  "block.minecraft.oxidized_copper_lantern": "Verdigris Coppern Lantern",
  "block.minecraft.oxidized_copper_trapdoor": "Verdigris Coppern Hatch",
  "block.minecraft.oxidized_cut_copper": "Oxidiz'd Cutteth Copp'r",
  "block.minecraft.oxidized_cut_copper_slab": "Oxidis'd Cutteth Copp'r Slab",
  "block.minecraft.oxidized_cut_copper_stairs": "Oxidiz'd Cutteth Copp'r Stairs",
  "block.minecraft.oxidized_lightning_rod": "The Lightning Rod, Cloaked in Time’s Verdant Shroud",
  "block.minecraft.packed_ice": "Press'd Ice",
  "block.minecraft.packed_mud": "Press'd Mud",
  "block.minecraft.pale_hanging_moss": "Pallor'd Hanging Moss",
  "block.minecraft.pale_moss_block": "Pallor'd Moss Block",
  "block.minecraft.pale_moss_carpet": "Pallor'd Moss Carpet",
  "block.minecraft.pale_oak_button": "Pallor Button",
  "block.minecraft.pale_oak_door": "Pallor Door",
  "block.minecraft.pale_oak_fence": "Pallor Hedge",
  "block.minecraft.pale_oak_fence_gate": "Pallor Hedge Gate",
  "block.minecraft.pale_oak_hanging_sign": "Pallor Hung Sign",
  "block.minecraft.pale_oak_leaves": "Pallor Leaves",
  "block.minecraft.pale_oak_log": "Pallor Log",
  "block.minecraft.pale_oak_planks": "Pallor Timber",
  "block.minecraft.pale_oak_pressure_plate": "Pallor Pressure Plate",
  "block.minecraft.pale_oak_sapling": "Pallor Sapling",
  "block.minecraft.pale_oak_shelf": "Pallor Shelf",
  "block.minecraft.pale_oak_sign": "Pallor Sign",
  "block.minecraft.pale_oak_slab": "Pallor Slab",
  "block.minecraft.pale_oak_stairs": "Pallor Stairs",
  "block.minecraft.pale_oak_trapdoor": "Pallor Hatch",
  "block.minecraft.pale_oak_wall_hanging_sign": "Pallor Hung Wallsign",
  "block.minecraft.pale_oak_wall_sign": "Pallor Hung Sign",
  "block.minecraft.pale_oak_wood": "Pallor Wood",
  "block.minecraft.pearlescent_froglight": "P'rlescent Froglight",
  "block.minecraft.peony": "Musk-Rose",
  "block.minecraft.petrified_oak_slab": "Slab o' Petrified Oak",
  "block.minecraft.piglin_head": "Piglin Head",
  "block.minecraft.piglin_wall_head": "Hung Piglin Head",
  "block.minecraft.pink_banner": "Carnation Banner",
  "block.minecraft.pink_bed": "Carnation Bed",
  "block.minecraft.pink_candle": "Carnation Candle",
  "block.minecraft.pink_candle_cake": "Pink Candle upon a Cake",
  "block.minecraft.pink_carpet": "Carnation Carpet",
  "block.minecraft.pink_concrete": "Carnelian Cement",
  "block.minecraft.pink_concrete_powder": "Carnelian Cement Powder",
  "block.minecraft.pink_glazed_terracotta": "Carnation Porcelain",
  "block.minecraft.pink_petals": "Pink petals",
  "block.minecraft.pink_shulker_box": "Carnation Shulker Case",
  "block.minecraft.pink_stained_glass": "Carnation-Coloured Glass",
  "block.minecraft.pink_stained_glass_pane": "Carnation-Coloured Glass Pane",
  "block.minecraft.pink_terracotta": "Carnation Earthen Block",
  "block.minecraft.pink_tulip": "Carnation",
  "block.minecraft.pink_wool": "Carnation Wool",
  "block.minecraft.piston": "Extender",
  "block.minecraft.piston_head": "Extender Head",
  "block.minecraft.pitcher_crop": "Pitch'r Crop",
  "block.minecraft.pitcher_plant": "Pitch'r Planteth",
  "block.minecraft.player_head": "Player's Head",
  "block.minecraft.player_head.named": "%s's Head",
  "block.minecraft.player_wall_head": "Hung Player Head",
  "block.minecraft.podzol": "Ashy Dirt",
  "block.minecraft.pointed_dripstone": "Point'd Dripstone",
  "block.minecraft.polished_andesite": "Grained Marble",
  "block.minecraft.polished_andesite_slab": "Grained Marble Slab",
  "block.minecraft.polished_andesite_stairs": "Grained Marble Stairs",
  "block.minecraft.polished_basalt": "Polish'd Basalt",
  "block.minecraft.polished_blackstone": "Polish'd Blackstone",
  "block.minecraft.polished_blackstone_brick_slab": "Polish'd Blackstone Brick Slab",
  "block.minecraft.polished_blackstone_brick_stairs": "Polish'd Blackstone Brick Stairs",
  "block.minecraft.polished_blackstone_brick_wall": "Polish'd Blackstone Brick Hedge",
  "block.minecraft.polished_blackstone_bricks": "Polish'd Blackstone Bricks",
  "block.minecraft.polished_blackstone_button": "Polish'd Blackstone Button",
  "block.minecraft.polished_blackstone_pressure_plate": "Polish'd Blackstone Pressure Plate",
  "block.minecraft.polished_blackstone_slab": "Polish'd Blackstone Slab",
  "block.minecraft.polished_blackstone_stairs": "Polish'd Blackstone Stairs",
  "block.minecraft.polished_blackstone_wall": "Polish'd Blackstone Hedge",
  "block.minecraft.polished_deepslate": "Polish'd Deepethslate",
  "block.minecraft.polished_deepslate_slab": "Polish'd Deepethslate Slab",
  "block.minecraft.polished_deepslate_stairs": "Polish'd Deepethslate Stairs",
  "block.minecraft.polished_deepslate_wall": "Polish'd Deepethslate Hedge",
  "block.minecraft.polished_diorite": "White Marble",
  "block.minecraft.polished_diorite_slab": "White Marble Slab",
  "block.minecraft.polished_diorite_stairs": "White Marble Stairs",
  "block.minecraft.polished_granite": "Red Grained Marble",
  "block.minecraft.polished_granite_slab": "Red Grained Marble Slab",
  "block.minecraft.polished_granite_stairs": "Red Grained Marble Stairs",
  "block.minecraft.polished_tuff": "Polish'd Tuff",
  "block.minecraft.polished_tuff_slab": "Polish'd Tuff Slab",
  "block.minecraft.polished_tuff_stairs": "Polish'd Tuff Stairs",
  "block.minecraft.polished_tuff_wall": "Polish'd Tuff Hedge",
  "block.minecraft.poppy": "Primrose",
  "block.minecraft.potatoes": "Potatoes",
  "block.minecraft.potted_acacia_sapling": "Pott'd Beech Sapling",
  "block.minecraft.potted_allium": "Pott'd Saffron",
  "block.minecraft.potted_azalea_bush": "Pott'd Shrub",
  "block.minecraft.potted_azure_bluet": "Pott'd Harebell",
  "block.minecraft.potted_bamboo": "Pott'd Bamboo",
  "block.minecraft.potted_birch_sapling": "Pott'd Birch Sapling",
  "block.minecraft.potted_blue_orchid": "Pott'd Violets",
  "block.minecraft.potted_brown_mushroom": "Pott'd Truffle",
  "block.minecraft.potted_cactus": "Pott'd Cactus",
  "block.minecraft.potted_cherry_sapling": "Pott'd Cherry Sapling",
  "block.minecraft.potted_closed_eyeblossom": "Pott'd Closed Eyeblossom",
  "block.minecraft.potted_cornflower": "Pott'd Pansy",
  "block.minecraft.potted_crimson_fungus": "Pott'd Crimson Mushrump",
  "block.minecraft.potted_crimson_roots": "Pott'd Crimson Rootes",
  "block.minecraft.potted_dandelion": "Pott'd Daffodil",
  "block.minecraft.potted_dark_oak_sapling": "Pott'd Ebony Sapling",
  "block.minecraft.potted_dead_bush": "Pott'd Wither'd Shrub",
  "block.minecraft.potted_fern": "Pott'd Fern",
  "block.minecraft.potted_flowering_azalea_bush": "Pott'd Flowering Shrub",
  "block.minecraft.potted_golden_dandelion": "Pott'd Gilded Daffodil",
  "block.minecraft.potted_jungle_sapling": "Pott'd Exotic Sapling",
  "block.minecraft.potted_lily_of_the_valley": "Pott'd Lily of the Valley",
  "block.minecraft.potted_mangrove_propagule": "Pott'd Marsh Bud",
  "block.minecraft.potted_oak_sapling": "Pott'd Oak Sapling",
  "block.minecraft.potted_open_eyeblossom": "Pott'd Open Eyeblossom",
  "block.minecraft.potted_orange_tulip": "Pott'd Tawny Carnation",
  "block.minecraft.potted_oxeye_daisy": "Pott'd Daisy",
  "block.minecraft.potted_pale_oak_sapling": "Pott'd Pallor Sapling",
  "block.minecraft.potted_pink_tulip": "Pott'd Carnation",
  "block.minecraft.potted_poppy": "Pott'd Primrose",
  "block.minecraft.potted_red_mushroom": "Pott'd Toadstool",
  "block.minecraft.potted_red_tulip": "Pott'd Crimson Carnation",
  "block.minecraft.potted_spruce_sapling": "Pott'd Pine Sapling",
  "block.minecraft.potted_torchflower": "Pott'd T'rchflow'r",
  "block.minecraft.potted_warped_fungus": "Pott'd Warp'd Fungus",
  "block.minecraft.potted_warped_roots": "Pott'd Warp'd Rootes",
  "block.minecraft.potted_white_tulip": "Pott'd White Carnation",
  "block.minecraft.potted_wither_rose": "Pott'd Wither'd Rose",
  "block.minecraft.powder_snow": "Powdered Snow",
  "block.minecraft.powder_snow_cauldron": "Casket of Powdered Snow",
  "block.minecraft.powered_rail": "Sparkling Iron-Rut",
  "block.minecraft.prismarine": "Prismarine",
  "block.minecraft.prismarine_brick_slab": "Prismarine Brick Slab",
  "block.minecraft.prismarine_brick_stairs": "Prismarine Brick Stairs",
  "block.minecraft.prismarine_bricks": "Prismarine Bricks",
  "block.minecraft.prismarine_slab": "Prismarine Slab",
  "block.minecraft.prismarine_stairs": "Prismarine Stairs",
  "block.minecraft.prismarine_wall": "Prismarine Hedge",
  "block.minecraft.pumpkin": "Pumpion",
  "block.minecraft.pumpkin_stem": "Pumpion Stem",
  "block.minecraft.purple_banner": "Purple Banner",
  "block.minecraft.purple_bed": "Purple Bed",
  "block.minecraft.purple_candle": "Purple Candle",
  "block.minecraft.purple_candle_cake": "Purple Candle upon a Cake",
  "block.minecraft.purple_carpet": "Purple Carpet",
  "block.minecraft.purple_concrete": "Purple Cement",
  "block.minecraft.purple_concrete_powder": "Purple Cement Powder",
  "block.minecraft.purple_glazed_terracotta": "Purple Porcelain",
  "block.minecraft.purple_shulker_box": "Purple Shulker Case",
  "block.minecraft.purple_stained_glass": "Purple-Coloured Glass",
  "block.minecraft.purple_stained_glass_pane": "Purple-Coloured Glass Pane",
  "block.minecraft.purple_terracotta": "Purple Earthen Block",
  "block.minecraft.purple_wool": "Purple Wool",
  "block.minecraft.purpur_block": "Block of Purpur",
  "block.minecraft.purpur_pillar": "Purpur Pillar",
  "block.minecraft.purpur_slab": "Purpur Slab",
  "block.minecraft.purpur_stairs": "Purpur Stairs",
  "block.minecraft.quartz_block": "Block of Quarz",
  "block.minecraft.quartz_bricks": "Quarz Bricks",
  "block.minecraft.quartz_pillar": "Pillar of Quarz",
  "block.minecraft.quartz_slab": "Quarz Slab",
  "block.minecraft.quartz_stairs": "Quarz Stairs",
  "block.minecraft.rail": "Rut of Iron",
  "block.minecraft.raw_copper_block": "Block of Raw Copp'r",
  "block.minecraft.raw_gold_block": "Block of Raw Gold",
  "block.minecraft.raw_iron_block": "Block of Raw Iron",
  "block.minecraft.red_banner": "Red Banner",
  "block.minecraft.red_bed": "Red Bed",
  "block.minecraft.red_candle": "Red Candle",
  "block.minecraft.red_candle_cake": "Red Candle upon a Cake",
  "block.minecraft.red_carpet": "Red Carpet",
  "block.minecraft.red_concrete": "Red Cement",
  "block.minecraft.red_concrete_powder": "Red Cement Powder",
  "block.minecraft.red_glazed_terracotta": "Red Porcelain",
  "block.minecraft.red_mushroom": "Red Mushroom",
  "block.minecraft.red_mushroom_block": "Block of Red Mushrooms",
  "block.minecraft.red_nether_brick_slab": "Red Nether Brick Slab",
  "block.minecraft.red_nether_brick_stairs": "Red Nether Brick Stairs",
  "block.minecraft.red_nether_brick_wall": "Red Nether Brick Hedge",
  "block.minecraft.red_nether_bricks": "Red Nether Bricks",
  "block.minecraft.red_sand": "Red Sand",
  "block.minecraft.red_sandstone": "Red Sandstone",
  "block.minecraft.red_sandstone_slab": "Red Sandstone Slab",
  "block.minecraft.red_sandstone_stairs": "Red Sandstone Stairs",
  "block.minecraft.red_sandstone_wall": "Red Sandstone Hedge",
  "block.minecraft.red_shulker_box": "Red Shulker Case",
  "block.minecraft.red_stained_glass": "Red-Coloured Glass",
  "block.minecraft.red_stained_glass_pane": "Red-Coloured Glass Pane",
  "block.minecraft.red_terracotta": "Red Earthen Block",
  "block.minecraft.red_tulip": "Crimson Carnation",
  "block.minecraft.red_wool": "Red Wool",
  "block.minecraft.redstone_block": "Block of Redstone",
  "block.minecraft.redstone_lamp": "Redstone Lamp",
  "block.minecraft.redstone_ore": "Redstone Ore",
  "block.minecraft.redstone_torch": "Redstone Torch",
  "block.minecraft.redstone_wall_torch": "Redstone Wall Torch",
  "block.minecraft.redstone_wire": "Redstone Trail",
  "block.minecraft.reinforced_deepslate": "Reinforced Deepethslate",
  "block.minecraft.repeater": "Redstone Repeater",
  "block.minecraft.repeating_command_block": "Repeating Command Block",
  "block.minecraft.resin_block": "Block of Hardened Sap",
  "block.minecraft.resin_brick_slab": "Hardened Sap Slab",
  "block.minecraft.resin_brick_stairs": "Hardened Sap Stairs",
  "block.minecraft.resin_brick_wall": "Hardened Sap Hedge",
  "block.minecraft.resin_bricks": "Hardened Sap Bricks",
  "block.minecraft.resin_clump": "Hardened Sap",
  "block.minecraft.respawn_anchor": "Respawn Anchor",
  "block.minecraft.rooted_dirt": "Root'd Dirt",
  "block.minecraft.rose_bush": "Rose Bush",
  "block.minecraft.sand": "Sand",
  "block.minecraft.sandstone": "Sandstone",
  "block.minecraft.sandstone_slab": "Sandstone Slab",
  "block.minecraft.sandstone_stairs": "Sandstone Stairs",
  "block.minecraft.sandstone_wall": "Sandstone Hedge",
  "block.minecraft.scaffolding": "Scaffolding",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculk Catalyst",
  "block.minecraft.sculk_sensor": "Sculk Detector",
  "block.minecraft.sculk_shrieker": "Sculk Shrieker",
  "block.minecraft.sculk_vein": "Sculk Vein",
  "block.minecraft.sea_lantern": "Sea Lantern",
  "block.minecraft.sea_pickle": "Sea Cucumber",
  "block.minecraft.seagrass": "Sargasso",
  "block.minecraft.set_spawn": "Reviving point establish'd",
  "block.minecraft.short_dry_grass": "Insignificant Thirsted Foilage",
  "block.minecraft.short_grass": "Short Grass",
  "block.minecraft.shroomlight": "Shroomlight",
  "block.minecraft.shulker_box": "Shulker Case",
  "block.minecraft.skeleton_skull": "Skull",
  "block.minecraft.skeleton_wall_skull": "Hung Skull",
  "block.minecraft.slime_block": "Block of Slime",
  "block.minecraft.small_amethyst_bud": "Small Amethyst Bud",
  "block.minecraft.small_dripleaf": "Small Dripleaf",
  "block.minecraft.smithing_table": "Smith's Table",
  "block.minecraft.smoker": "Smoker",
  "block.minecraft.smooth_basalt": "Smooth Basalt",
  "block.minecraft.smooth_quartz": "Block of Smooth Quarz",
  "block.minecraft.smooth_quartz_slab": "Smooth Quarz Slab",
  "block.minecraft.smooth_quartz_stairs": "Smooth Quarz Stairs",
  "block.minecraft.smooth_red_sandstone": "Smooth Red Sandstone",
  "block.minecraft.smooth_red_sandstone_slab": "Smooth Red Sandstone Slab",
  "block.minecraft.smooth_red_sandstone_stairs": "Smooth Red Sandstone Stairs",
  "block.minecraft.smooth_sandstone": "Smooth Sandstone",
  "block.minecraft.smooth_sandstone_slab": "Smooth Sandstone Slab",
  "block.minecraft.smooth_sandstone_stairs": "Smooth Sandstone Stairs",
  "block.minecraft.smooth_stone": "Smooth Stone",
  "block.minecraft.smooth_stone_slab": "Smooth Stone Slab",
  "block.minecraft.sniffer_egg": "Sniffener Egg",
  "block.minecraft.snow": "Snow",
  "block.minecraft.snow_block": "Block of Snow",
  "block.minecraft.soul_campfire": "Campfire of Soules",
  "block.minecraft.soul_fire": "Soule Fire",
  "block.minecraft.soul_lantern": "Soule Lantern",
  "block.minecraft.soul_sand": "Quicksand",
  "block.minecraft.soul_soil": "Soil of Soules",
  "block.minecraft.soul_torch": "Soule Torch",
  "block.minecraft.soul_wall_torch": "Wall-mounted Soule Torch",
  "block.minecraft.spawn.not_valid": "Thou hath no home bed or respawn anchor, or it hath been obstructed",
  "block.minecraft.spawner": "Creature Spawner",
  "block.minecraft.spawner.desc1": "Interact with Adder Stone:",
  "block.minecraft.spawner.desc2": "Sets Creature Typ",
  "block.minecraft.sponge": "Sponge",
  "block.minecraft.spore_blossom": "Sp're Blossom",
  "block.minecraft.spruce_button": "Pine Button",
  "block.minecraft.spruce_door": "Pine Door",
  "block.minecraft.spruce_fence": "Pine Hedge",
  "block.minecraft.spruce_fence_gate": "Pine Hedge Gate",
  "block.minecraft.spruce_hanging_sign": "Pine Hung Sign",
  "block.minecraft.spruce_leaves": "Pine Needles",
  "block.minecraft.spruce_log": "Pine Log",
  "block.minecraft.spruce_planks": "Pine Timber",
  "block.minecraft.spruce_pressure_plate": "Pine Pressure Plate",
  "block.minecraft.spruce_sapling": "Pine Sapling",
  "block.minecraft.spruce_shelf": "Pine Shelf",
  "block.minecraft.spruce_sign": "Pine Sign",
  "block.minecraft.spruce_slab": "Pine Slab",
  "block.minecraft.spruce_stairs": "Pine Stairs",
  "block.minecraft.spruce_trapdoor": "Pine Hatch",
  "block.minecraft.spruce_wall_hanging_sign": "Pine Hung Wallsign",
  "block.minecraft.spruce_wall_sign": "Pine Hung Sign",
  "block.minecraft.spruce_wood": "Pine Log",
  "block.minecraft.sticky_piston": "Gluey Extruder",
  "block.minecraft.stone": "Stone",
  "block.minecraft.stone_brick_slab": "Stone Brick Slab",
  "block.minecraft.stone_brick_stairs": "Stone Brick Stairs",
  "block.minecraft.stone_brick_wall": "Stone Brick Hedge",
  "block.minecraft.stone_bricks": "Stone Bricks",
  "block.minecraft.stone_button": "Stone Button",
  "block.minecraft.stone_pressure_plate": "Stone Pressure Plate",
  "block.minecraft.stone_slab": "Stone Slab",
  "block.minecraft.stone_stairs": "Stone Stairs",
  "block.minecraft.stonecutter": "Masons Table",
  "block.minecraft.stripped_acacia_log": "Hulled Beech Log",
  "block.minecraft.stripped_acacia_wood": "Hulled Beechen Wood",
  "block.minecraft.stripped_bamboo_block": "Block of Hulled Bamboo",
  "block.minecraft.stripped_birch_log": "Hulled Birch Log",
  "block.minecraft.stripped_birch_wood": "Hulled Birchen Wood",
  "block.minecraft.stripped_cherry_log": "Hulled Cherry Log",
  "block.minecraft.stripped_cherry_wood": "Hulled Cherry Wood",
  "block.minecraft.stripped_crimson_hyphae": "Debarked Crimson Hyphae",
  "block.minecraft.stripped_crimson_stem": "Bare Crimson Stem",
  "block.minecraft.stripped_dark_oak_log": "Hulled Ebony Log",
  "block.minecraft.stripped_dark_oak_wood": "Hulled Ebon Wood",
  "block.minecraft.stripped_jungle_log": "Hulled Exotic Log",
  "block.minecraft.stripped_jungle_wood": "Hulled Exotic Wood",
  "block.minecraft.stripped_mangrove_log": "Hulled Marsh Log",
  "block.minecraft.stripped_mangrove_wood": "Hulled Marsh Wood",
  "block.minecraft.stripped_oak_log": "Hulled Oak Log",
  "block.minecraft.stripped_oak_wood": "Hulled Oaken Wood",
  "block.minecraft.stripped_pale_oak_log": "Hulled Pallor Log",
  "block.minecraft.stripped_pale_oak_wood": "Hulled Pallor Wood",
  "block.minecraft.stripped_spruce_log": "Hulled Pine Log",
  "block.minecraft.stripped_spruce_wood": "Hulled Pine Wood",
  "block.minecraft.stripped_warped_hyphae": "Debarked Warped Hyphae",
  "block.minecraft.stripped_warped_stem": "Bare Warp'd Stem",
  "block.minecraft.structure_block": "Structure Block",
  "block.minecraft.structure_void": "Structure Void",
  "block.minecraft.sugar_cane": "Sugar Cane",
  "block.minecraft.sunflower": "Heliotrope",
  "block.minecraft.suspicious_gravel": "Suspicious Gravel",
  "block.minecraft.suspicious_sand": "Suspicious Sand",
  "block.minecraft.sweet_berry_bush": "Sweet Berry Bush",
  "block.minecraft.tall_dry_grass": "Significant Thirsted Foilage",
  "block.minecraft.tall_grass": "Tall Grass",
  "block.minecraft.tall_seagrass": "Tall Sargasso",
  "block.minecraft.target": "Target",
  "block.minecraft.terracotta": "Earthen Block",
  "block.minecraft.test_block": "Cube of Trial and Error",
  "block.minecraft.test_instance_block": "Scene Cube of Trial and Error",
  "block.minecraft.tinted_glass": "Tint'd Glass",
  "block.minecraft.tnt": "Petard",
  "block.minecraft.tnt.disabled": "Petards shall not burst",
  "block.minecraft.torch": "Torch",
  "block.minecraft.torchflower": "T'rchflow'r",
  "block.minecraft.torchflower_crop": "T'rchflow'r Crop",
  "block.minecraft.trapped_chest": "Entrapped Chest",
  "block.minecraft.trial_spawner": "Trial Spawner",
  "block.minecraft.tripwire": "Tripping String",
  "block.minecraft.tripwire_hook": "Tripping Hook",
  "block.minecraft.tube_coral": "Blue Coral",
  "block.minecraft.tube_coral_block": "Block of Blue Coral",
  "block.minecraft.tube_coral_fan": "Small Blue Coral",
  "block.minecraft.tube_coral_wall_fan": "Small Hanging Blue Coral",
  "block.minecraft.tuff": "Tuff",
  "block.minecraft.tuff_brick_slab": "Tuff Brick Slab",
  "block.minecraft.tuff_brick_stairs": "Tuff Brick Stairs",
  "block.minecraft.tuff_brick_wall": "Tuff Brick Hedge",
  "block.minecraft.tuff_bricks": "Tuff Bricks",
  "block.minecraft.tuff_slab": "Tuff Slab",
  "block.minecraft.tuff_stairs": "Tuff Stairs",
  "block.minecraft.tuff_wall": "Tuff Hedge",
  "block.minecraft.turtle_egg": "Turtle Egg",
  "block.minecraft.twisting_vines": "Twisting Tendrils",
  "block.minecraft.twisting_vines_plant": "Twisting Tendrils Plant",
  "block.minecraft.vault": "Vault",
  "block.minecraft.verdant_froglight": "V'rdant Froglight",
  "block.minecraft.vine": "Vines",
  "block.minecraft.void_air": "Void Air",
  "block.minecraft.wall_torch": "Hung Torch",
  "block.minecraft.warped_button": "Warpwood Button",
  "block.minecraft.warped_door": "Warpwood Door",
  "block.minecraft.warped_fence": "Warpwood Hedge",
  "block.minecraft.warped_fence_gate": "Warpwood Hedge Gate",
  "block.minecraft.warped_fungus": "Warped Mushrump",
  "block.minecraft.warped_hanging_sign": "Warp'd Hanging Signeth",
  "block.minecraft.warped_hyphae": "Warp'd Hyphæ",
  "block.minecraft.warped_nylium": "Warp'd Nylium",
  "block.minecraft.warped_planks": "Warpwood Timer",
  "block.minecraft.warped_pressure_plate": "Warpwood Pressure Plate",
  "block.minecraft.warped_roots": "Warp'd Rootes",
  "block.minecraft.warped_shelf": "Warpwood Shelf",
  "block.minecraft.warped_sign": "Warpwood Sign",
  "block.minecraft.warped_slab": "Warpwood Slab",
  "block.minecraft.warped_stairs": "Warpwood Stairs",
  "block.minecraft.warped_stem": "Warp'd Stem",
  "block.minecraft.warped_trapdoor": "Warpwood Hatch",
  "block.minecraft.warped_wall_hanging_sign": "Warp'd Mure Hanging Signeth",
  "block.minecraft.warped_wall_sign": "Warpwood Wallsign",
  "block.minecraft.warped_wart_block": "Block of Warp'd Wart",
  "block.minecraft.water": "Water",
  "block.minecraft.water_cauldron": "Casket of Water",
  "block.minecraft.waxed_chiseled_copper": "Waxed Chiseled Copper",
  "block.minecraft.waxed_copper_bars": "Waxed Coppern Bars",
  "block.minecraft.waxed_copper_block": "Wax'd Block of Copp'r",
  "block.minecraft.waxed_copper_bulb": "Waxed Coppern Bulb",
  "block.minecraft.waxed_copper_chain": "Waxed Coppern Chain",
  "block.minecraft.waxed_copper_chest": "Waxed Coppern Chest",
  "block.minecraft.waxed_copper_door": "Waxed Coppern Door",
  "block.minecraft.waxed_copper_golem_statue": "Waxed Coppern Homunculus Statue",
  "block.minecraft.waxed_copper_grate": "Waxed Coppern Grate",
  "block.minecraft.waxed_copper_lantern": "Waxed Coppern Lantern",
  "block.minecraft.waxed_copper_trapdoor": "Waxed Coppern Hatch",
  "block.minecraft.waxed_cut_copper": "Wax'd Cutteth Copp'r",
  "block.minecraft.waxed_cut_copper_slab": "Wax'd Cutteth Copp'r Slab",
  "block.minecraft.waxed_cut_copper_stairs": "Wax'd Cutteth Copp'r Stairs",
  "block.minecraft.waxed_exposed_chiseled_copper": "Waxed Tarnished Chiseled Copper",
  "block.minecraft.waxed_exposed_copper": "Wax'd Expos'd Copp'r",
  "block.minecraft.waxed_exposed_copper_bars": "Waxed Tarnished Coppern Bars",
  "block.minecraft.waxed_exposed_copper_bulb": "Waxed Tarnished Coppern Bulb",
  "block.minecraft.waxed_exposed_copper_chain": "Waxed Tarnished Coppern Chain",
  "block.minecraft.waxed_exposed_copper_chest": "Waxed Tarnished Coppern Chest",
  "block.minecraft.waxed_exposed_copper_door": "Waxed Tarnished Coppern Door",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waxed Tarnished Coppern Homunculus Statue",
  "block.minecraft.waxed_exposed_copper_grate": "Waxed Tarnished Coppern Grate",
  "block.minecraft.waxed_exposed_copper_lantern": "Waxed Tarnished Coppern Lantern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Waxed Tarnished Coppern Hatch",
  "block.minecraft.waxed_exposed_cut_copper": "Wax'd Expos'd Cutteth Copp'r",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Wax'd Expos'd Cutteth Copp'r Slab",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Wax'd Expos'd Cutteth Copp'r Stairs",
  "block.minecraft.waxed_exposed_lightning_rod": "The Lightning Rod, Unshrouded and Bright with Waxen Sheen",
  "block.minecraft.waxed_lightning_rod": "The Rod of Thunder, Brightened by Lustrous Wax",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Waxed Verdigris Chiseled Copper",
  "block.minecraft.waxed_oxidized_copper": "Wax'd Oxidis'd Copp'r",
  "block.minecraft.waxed_oxidized_copper_bars": "Waxed Verdigris Coppern Bars",
  "block.minecraft.waxed_oxidized_copper_bulb": "Waxed Verdigris Coppern Bulb",
  "block.minecraft.waxed_oxidized_copper_chain": "Waxed Verdigris Coppern Chain",
  "block.minecraft.waxed_oxidized_copper_chest": "Waxed Verdigris Coppern Chest",
  "block.minecraft.waxed_oxidized_copper_door": "Waxed Verdigris Coppern Door",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Waxed Verdigris Coppern Homunculus Statue",
  "block.minecraft.waxed_oxidized_copper_grate": "Waxed Verdigris Coppern Grate",
  "block.minecraft.waxed_oxidized_copper_lantern": "Waxed Verdigris Coppern Lantern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Waxed Verdigris Coppern Hatch",
  "block.minecraft.waxed_oxidized_cut_copper": "Wax'd Oxidis'd Cutteth Copp'r",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Wax'd Oxidis'd Cutteth Copp'r Slab",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Wax'd Oxidis'd Cutteth Copp'r Stairs",
  "block.minecraft.waxed_oxidized_lightning_rod": "The Lightning Rod, Cloaked in Time’s Verdant Mantle and Polished with a Waxen Gleam",
  "block.minecraft.waxed_weathered_chiseled_copper": "Waxed Weathered Chiseled Copper",
  "block.minecraft.waxed_weathered_copper": "Wax'd Weather'd Copp'r",
  "block.minecraft.waxed_weathered_copper_bars": "Waxed Weathered Coppern Bars",
  "block.minecraft.waxed_weathered_copper_bulb": "Waxed Weathered Coppern Bulb",
  "block.minecraft.waxed_weathered_copper_chain": "Waxen and Weather'd Chain o' Copper",
  "block.minecraft.waxed_weathered_copper_chest": "Waxen and Weather'd Coffer of Copper",
  "block.minecraft.waxed_weathered_copper_door": "Waxed Weathered Coppern Door",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Waxen and Weather'd Golem of Copper Statue",
  "block.minecraft.waxed_weathered_copper_grate": "Waxed Weathered Coppern Grate",
  "block.minecraft.waxed_weathered_copper_lantern": "Waxen and Weather'd Lantern o' Copper",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Waxed Weathered Copper Hatch",
  "block.minecraft.waxed_weathered_cut_copper": "Wax'd Weather'd Cutteth Copp'r",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Wax'd Weather'd Cutteth Copp'r Slab",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Wax'd Weather'd Cutteth Copp'r Stairs",
  "block.minecraft.waxed_weathered_lightning_rod": "Waxen and Weather'd Rod o'th' Lightning",
  "block.minecraft.weathered_chiseled_copper": "Weathered Chiseled Copper",
  "block.minecraft.weathered_copper": "Weather'd Copp'r",
  "block.minecraft.weathered_copper_bars": "Weather'd Bars o' Copper",
  "block.minecraft.weathered_copper_bulb": "Weathered Coppern Bulb",
  "block.minecraft.weathered_copper_chain": "Weather'd Chain o' Copper",
  "block.minecraft.weathered_copper_chest": "Weather'd Coffer of Copper",
  "block.minecraft.weathered_copper_door": "Weathered Coppern Door",
  "block.minecraft.weathered_copper_golem_statue": "Weather'd Golem of Copper Statue",
  "block.minecraft.weathered_copper_grate": "Weathered Coppern Grate",
  "block.minecraft.weathered_copper_lantern": "Weather'd Lantern o' Copper",
  "block.minecraft.weathered_copper_trapdoor": "Weathered Coppern Hatch",
  "block.minecraft.weathered_cut_copper": "Weather'd Cutteth Copp'r",
  "block.minecraft.weathered_cut_copper_slab": "Weather'd Cutteth Copp'r Slab",
  "block.minecraft.weathered_cut_copper_stairs": "Weather'd Cutteth Copp'r Stairs",
  "block.minecraft.weathered_lightning_rod": "Weather'd Rod o'th' Lightning",
  "block.minecraft.weeping_vines": "Weeping Tendrils",
  "block.minecraft.weeping_vines_plant": "Weeping Tendrils Plant",
  "block.minecraft.wet_sponge": "Wet Sponge",
  "block.minecraft.wheat": "Wheat Crops",
  "block.minecraft.white_banner": "White Banner",
  "block.minecraft.white_bed": "White Bed",
  "block.minecraft.white_candle": "White Candle",
  "block.minecraft.white_candle_cake": "White Candle upon a Cake",
  "block.minecraft.white_carpet": "White Carpet",
  "block.minecraft.white_concrete": "White Cement",
  "block.minecraft.white_concrete_powder": "White Cement Powder",
  "block.minecraft.white_glazed_terracotta": "White Porcelain",
  "block.minecraft.white_shulker_box": "White Shulker Case",
  "block.minecraft.white_stained_glass": "White-Coloured Glass",
  "block.minecraft.white_stained_glass_pane": "White-Coloured Glass Pane",
  "block.minecraft.white_terracotta": "White Earthen Block",
  "block.minecraft.white_tulip": "White Carnation",
  "block.minecraft.white_wool": "White Wool",
  "block.minecraft.wildflowers": "Wildflow'rs",
  "block.minecraft.wither_rose": "Wither'd Rose",
  "block.minecraft.wither_skeleton_skull": "Wither'd Skull",
  "block.minecraft.wither_skeleton_wall_skull": "Hung Wither'd Skull",
  "block.minecraft.yellow_banner": "Yellow Banner",
  "block.minecraft.yellow_bed": "Yellow Bed",
  "block.minecraft.yellow_candle": "Yellow Candle",
  "block.minecraft.yellow_candle_cake": "Yellow Candle upon a Cake",
  "block.minecraft.yellow_carpet": "Yellow Carpet",
  "block.minecraft.yellow_concrete": "Yellow Cement",
  "block.minecraft.yellow_concrete_powder": "Yellow Cement Powder",
  "block.minecraft.yellow_glazed_terracotta": "Yellow Porcelain",
  "block.minecraft.yellow_shulker_box": "Yellow Shulker Case",
  "block.minecraft.yellow_stained_glass": "Yellow-Coloured Glass",
  "block.minecraft.yellow_stained_glass_pane": "Yellow-Coloured Glass Pane",
  "block.minecraft.yellow_terracotta": "Yellow Earthen Block",
  "block.minecraft.yellow_wool": "Yellow Wool",
  "block.minecraft.zombie_head": "Rotten Head",
  "block.minecraft.zombie_wall_head": "Hung Rotten Head",
  "item.minecraft.acacia_boat": "Beechen Boat",
  "item.minecraft.acacia_chest_boat": "Chest in a Beechen Boat",
  "item.minecraft.allay_spawn_egg": "Adder Stone o' Fairy",
  "item.minecraft.amethyst_shard": "Amethyst Shard",
  "item.minecraft.angler_pottery_shard": "Angler Pot Shard",
  "item.minecraft.angler_pottery_sherd": "Angler Potsherd",
  "item.minecraft.apple": "Apple",
  "item.minecraft.archer_pottery_shard": "Archer Pottery Shard",
  "item.minecraft.archer_pottery_sherd": "Archer Potsherd",
  "item.minecraft.armadillo_scute": "Armadillo Scale",
  "item.minecraft.armadillo_spawn_egg": "Adder Stone o' Armadillo",
  "item.minecraft.armor_stand": "Armour Stand",
  "item.minecraft.arms_up_pottery_shard": "Elevated limbs Potters Shard",
  "item.minecraft.arms_up_pottery_sherd": "Up In Arms Potsherd",
  "item.minecraft.arrow": "Arrow",
  "item.minecraft.axolotl_bucket": "Axolotl in a Bucket",
  "item.minecraft.axolotl_spawn_egg": "Adder Stone o' Axolotl",
  "item.minecraft.baked_potato": "Roasted Potato",
  "item.minecraft.bamboo_chest_raft": "Chest in a Bamboo Vessel",
  "item.minecraft.bamboo_raft": "Bamboo Vessel",
  "item.minecraft.bat_spawn_egg": "Adder Stone o' Bat",
  "item.minecraft.bee_spawn_egg": "Adder Stone o' Bee",
  "item.minecraft.beef": "Raw Beef",
  "item.minecraft.beetroot": "Beet",
  "item.minecraft.beetroot_seeds": "Beet Seeds",
  "item.minecraft.beetroot_soup": "Beet Soup",
  "item.minecraft.birch_boat": "Birchen Boat",
  "item.minecraft.birch_chest_boat": "Chest in a Birchen Boat",
  "item.minecraft.black_bundle": "Black Fardel",
  "item.minecraft.black_dye": "Black Dye",
  "item.minecraft.black_harness": "Black Harness",
  "item.minecraft.blade_pottery_shard": "The Pen is Mightier Than the Shwerd",
  "item.minecraft.blade_pottery_sherd": "Blade Potsherd",
  "item.minecraft.blaze_powder": "Brimstone Powder",
  "item.minecraft.blaze_rod": "Red-hot Rod",
  "item.minecraft.blaze_spawn_egg": "Adder Stone of Will o' the Wisp",
  "item.minecraft.blue_bundle": "Blue Fardel",
  "item.minecraft.blue_dye": "Blue Dye",
  "item.minecraft.blue_egg": "Spherical Blue",
  "item.minecraft.blue_harness": "Blue Harness",
  "item.minecraft.bogged_spawn_egg": "Adder Stone o' Muddy Dead",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolt Armour Trimming",
  "item.minecraft.bone": "Bone",
  "item.minecraft.bone_meal": "Bone Powder",
  "item.minecraft.book": "Book",
  "item.minecraft.bordure_indented_banner_pattern": "The Banner’s Bordure, Marked with Notches and Indentures",
  "item.minecraft.bow": "Bow",
  "item.minecraft.bowl": "Bowl",
  "item.minecraft.bread": "Bread",
  "item.minecraft.breeze_rod": "Sylph Rod",
  "item.minecraft.breeze_spawn_egg": "Adder Stone o' Sylph",
  "item.minecraft.brewer_pottery_shard": "Brewer Pottery Shardth",
  "item.minecraft.brewer_pottery_sherd": "Brewer Potsherd",
  "item.minecraft.brewing_stand": "Alchemy Table",
  "item.minecraft.brick": "Brick",
  "item.minecraft.brown_bundle": "Brown Fardel",
  "item.minecraft.brown_dye": "Brown Dye",
  "item.minecraft.brown_egg": "Spherical Brown",
  "item.minecraft.brown_harness": "Brown Harness",
  "item.minecraft.brush": "Brush",
  "item.minecraft.bucket": "Bucket",
  "item.minecraft.bundle": "Fardel",
  "item.minecraft.bundle.empty": "Empty",
  "item.minecraft.bundle.empty.description": "Canst bear a mingled heap of wares",
  "item.minecraft.bundle.full": "Full",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Burn Potshard",
  "item.minecraft.burn_pottery_sherd": "Burn Potsherd",
  "item.minecraft.camel_husk_spawn_egg": "Adder Stone o' Camall Gortach",
  "item.minecraft.camel_spawn_egg": "Adder Stone o' Camel",
  "item.minecraft.carrot": "Caret",
  "item.minecraft.carrot_on_a_stick": "Caret o'Stick",
  "item.minecraft.cat_spawn_egg": "Adder Stone o' Cat",
  "item.minecraft.cauldron": "Caldron",
  "item.minecraft.cave_spider_spawn_egg": "Adder Stone o' Cave Spider",
  "item.minecraft.chainmail_boots": "Mailed Sabatons",
  "item.minecraft.chainmail_chestplate": "Mailed Hauberk",
  "item.minecraft.chainmail_helmet": "Mailed Coif",
  "item.minecraft.chainmail_leggings": "Mailed Hose",
  "item.minecraft.charcoal": "Charcoal",
  "item.minecraft.cherry_boat": "Cherry Boat",
  "item.minecraft.cherry_chest_boat": "Chest in a Cherry Boat",
  "item.minecraft.chest_minecart": "Chest in a Cart",
  "item.minecraft.chicken": "Raw Fowl",
  "item.minecraft.chicken_spawn_egg": "Adder Stone o' Fowl",
  "item.minecraft.chorus_fruit": "Chorus Fruit",
  "item.minecraft.clay_ball": "Ball of Clay",
  "item.minecraft.clock": "Clock",
  "item.minecraft.coal": "Coal",
  "item.minecraft.coast_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Coast Armour Trim",
  "item.minecraft.cocoa_beans": "Cocoa Beans",
  "item.minecraft.cod": "Raw Cod",
  "item.minecraft.cod_bucket": "Cod in a Bucket",
  "item.minecraft.cod_spawn_egg": "Adder Stone o' Cod",
  "item.minecraft.command_block_minecart": "Command Block in a Cart",
  "item.minecraft.compass": "Compass",
  "item.minecraft.cooked_beef": "Roasted Beef",
  "item.minecraft.cooked_chicken": "Roasted Fowl",
  "item.minecraft.cooked_cod": "Cooked Cod",
  "item.minecraft.cooked_mutton": "Roasted Mutton",
  "item.minecraft.cooked_porkchop": "Roasted Bacon",
  "item.minecraft.cooked_rabbit": "Roasted Hare",
  "item.minecraft.cooked_salmon": "Cooked Salmon",
  "item.minecraft.cookie": "Biscuit",
  "item.minecraft.copper_axe": "Coppern Axe",
  "item.minecraft.copper_boots": "Coppern Boots",
  "item.minecraft.copper_chestplate": "Coppern Corselet",
  "item.minecraft.copper_golem_spawn_egg": "Coppern Homunculus' Atter Stone",
  "item.minecraft.copper_helmet": "Coppern Helm",
  "item.minecraft.copper_hoe": "Coppern Hoe",
  "item.minecraft.copper_horse_armor": "Coppern Barding",
  "item.minecraft.copper_ingot": "Copp'r Ingot",
  "item.minecraft.copper_leggings": "Coppern Greaves",
  "item.minecraft.copper_nautilus_armor": "Copp'r Nautilus Armour",
  "item.minecraft.copper_nugget": "Coppern Nugget",
  "item.minecraft.copper_pickaxe": "Coppern Pickaxe",
  "item.minecraft.copper_shovel": "Coppern Shovel",
  "item.minecraft.copper_spear": "Coppern Lance",
  "item.minecraft.copper_sword": "Coppern Sword",
  "item.minecraft.cow_spawn_egg": "Adder Stone o' Cow",
  "item.minecraft.creaking_spawn_egg": "Adder Stone o' Creaking",
  "item.minecraft.creeper_banner_pattern": "Creeper Banner Pattern",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper Charge",
  "item.minecraft.creeper_banner_pattern.new": "Creeper Charge Banner Pattern",
  "item.minecraft.creeper_spawn_egg": "Adder Stone o' Creeper",
  "item.minecraft.crossbow": "Cross-Bow",
  "item.minecraft.crossbow.projectile": "Bolt:",
  "item.minecraft.crossbow.projectile.multiple": "Bolt: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Bolt: %s",
  "item.minecraft.cyan_bundle": "Turquoise Fardel",
  "item.minecraft.cyan_dye": "Turquoise Dye",
  "item.minecraft.cyan_harness": "Turquoise Harness",
  "item.minecraft.danger_pottery_shard": "Danger Potshard",
  "item.minecraft.danger_pottery_sherd": "Danger Potsherd",
  "item.minecraft.dark_oak_boat": "Ebony Boat",
  "item.minecraft.dark_oak_chest_boat": "Chest in an Ebony Boat",
  "item.minecraft.debug_stick": "Stick o' Remedy",
  "item.minecraft.debug_stick.empty": "%s hath properties of naught",
  "item.minecraft.debug_stick.select": "'tis \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" to %s",
  "item.minecraft.diamond": "Diamond",
  "item.minecraft.diamond_axe": "Diamond Axe",
  "item.minecraft.diamond_boots": "Diamond Sabatons",
  "item.minecraft.diamond_chestplate": "Diamond Breast Plate",
  "item.minecraft.diamond_helmet": "Diamond Casque",
  "item.minecraft.diamond_hoe": "Diamond Hoe",
  "item.minecraft.diamond_horse_armor": "Horse Barding of Diamond",
  "item.minecraft.diamond_leggings": "Diamond Greaves",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armour",
  "item.minecraft.diamond_pickaxe": "Diamond Pickaxe",
  "item.minecraft.diamond_shovel": "Diamond Spade",
  "item.minecraft.diamond_spear": "Diamond Lance",
  "item.minecraft.diamond_sword": "Diamond Sword",
  "item.minecraft.disc_fragment_5": "Disc Fragment",
  "item.minecraft.disc_fragment_5.desc": "Music Plate - 5",
  "item.minecraft.dolphin_spawn_egg": "Adder Stone o' Dolphin",
  "item.minecraft.donkey_spawn_egg": "Adder Stone o' Ass",
  "item.minecraft.dragon_breath": "Dragons Breath",
  "item.minecraft.dried_kelp": "Dried Seaweed",
  "item.minecraft.drowned_spawn_egg": "Adder Stone o' Grindylow",
  "item.minecraft.dune_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dune Armour Trim",
  "item.minecraft.echo_shard": "Echo Shard",
  "item.minecraft.egg": "Egg",
  "item.minecraft.elder_guardian_spawn_egg": "Adder Stone o' Morgen Sprite",
  "item.minecraft.elytra": "Wings",
  "item.minecraft.emerald": "Emerald",
  "item.minecraft.enchanted_book": "Enchanted Book",
  "item.minecraft.enchanted_golden_apple": "Bewitch'd Gilded Apple",
  "item.minecraft.end_crystal": "End Crystal",
  "item.minecraft.ender_dragon_spawn_egg": "Adder Stone o' Ender Dragon",
  "item.minecraft.ender_eye": "Bewitch'd Ender Pearl",
  "item.minecraft.ender_pearl": "Ender Pearl",
  "item.minecraft.enderman_spawn_egg": "Adder Stone o' Enderman",
  "item.minecraft.endermite_spawn_egg": "Adder Stone o' Endermite",
  "item.minecraft.evoker_spawn_egg": "Adder Stone o' Sorcerer",
  "item.minecraft.experience_bottle": "Bottle o' Bewitchment",
  "item.minecraft.explorer_pottery_shard": "Voyager Potshard",
  "item.minecraft.explorer_pottery_sherd": "Voyager Potsherd",
  "item.minecraft.eye_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Dune Armour Trim",
  "item.minecraft.feather": "Feather",
  "item.minecraft.fermented_spider_eye": "Fermented Spider Eye",
  "item.minecraft.field_masoned_banner_pattern": "The Banner Embarked with the Masoned Field, as Stones in Order Set",
  "item.minecraft.filled_map": "Map",
  "item.minecraft.fire_charge": "Blasting Charge",
  "item.minecraft.firework_rocket": "Firework",
  "item.minecraft.firework_rocket.flight": "Length of Burn:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Firework Charge",
  "item.minecraft.firework_star.black": "Black",
  "item.minecraft.firework_star.blue": "Blue",
  "item.minecraft.firework_star.brown": "Brown",
  "item.minecraft.firework_star.custom_color": "Custom",
  "item.minecraft.firework_star.cyan": "Turquoise",
  "item.minecraft.firework_star.fade_to": "Fade to",
  "item.minecraft.firework_star.flicker": "Twinkle",
  "item.minecraft.firework_star.gray": "Grey",
  "item.minecraft.firework_star.green": "Green",
  "item.minecraft.firework_star.light_blue": "Whey",
  "item.minecraft.firework_star.light_gray": "Pale Grey",
  "item.minecraft.firework_star.lime": "Lincoln",
  "item.minecraft.firework_star.magenta": "Mulberry",
  "item.minecraft.firework_star.orange": "Tawny",
  "item.minecraft.firework_star.pink": "Carnation",
  "item.minecraft.firework_star.purple": "Purple",
  "item.minecraft.firework_star.red": "Red",
  "item.minecraft.firework_star.shape": "Unknown Shape",
  "item.minecraft.firework_star.shape.burst": "Burst",
  "item.minecraft.firework_star.shape.creeper": "Creeper shaped",
  "item.minecraft.firework_star.shape.large_ball": "Large Ball",
  "item.minecraft.firework_star.shape.small_ball": "Small Ball",
  "item.minecraft.firework_star.shape.star": "Star-shape",
  "item.minecraft.firework_star.trail": "Trail",
  "item.minecraft.firework_star.white": "White",
  "item.minecraft.firework_star.yellow": "Yellow",
  "item.minecraft.fishing_rod": "Fishing Rod",
  "item.minecraft.flint": "Flint",
  "item.minecraft.flint_and_steel": "Flint and Steel",
  "item.minecraft.flow_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Flow Armour Trim",
  "item.minecraft.flow_banner_pattern": "Banner Pattern",
  "item.minecraft.flow_banner_pattern.desc": "Current",
  "item.minecraft.flow_banner_pattern.new": "The Banner’s Design, Softly Wrought in Flowing Lines",
  "item.minecraft.flow_pottery_sherd": "Flow Potsherd",
  "item.minecraft.flower_banner_pattern": "Banner Pattern",
  "item.minecraft.flower_banner_pattern.desc": "Flower Charge",
  "item.minecraft.flower_banner_pattern.new": "Banner Pattern Bedecked With Blossoming Charge.",
  "item.minecraft.flower_pot": "Flower Pot",
  "item.minecraft.fox_spawn_egg": "Adder Stone o' Fox",
  "item.minecraft.friend_pottery_shard": "Friend Potshard",
  "item.minecraft.friend_pottery_sherd": "Friend Potsherd",
  "item.minecraft.frog_spawn_egg": "Adder Stone o' Frog",
  "item.minecraft.furnace_minecart": "Furnace in a Cart",
  "item.minecraft.ghast_spawn_egg": "Adder Stone o' Ghast",
  "item.minecraft.ghast_tear": "Ghast Tear",
  "item.minecraft.glass_bottle": "Glass Bottle",
  "item.minecraft.glistering_melon_slice": "Gilded Melon Piece",
  "item.minecraft.globe_banner_pattern": "Banner Pattern",
  "item.minecraft.globe_banner_pattern.desc": "Globe",
  "item.minecraft.globe_banner_pattern.new": "The Banner Pattern of the Globe, Marking the World Whole",
  "item.minecraft.glow_berries": "Glowen Berries",
  "item.minecraft.glow_ink_sac": "Glowen Ink Sack",
  "item.minecraft.glow_item_frame": "Glowen Item Frame",
  "item.minecraft.glow_squid_spawn_egg": "Adder Stone o' Glowen Cuttlefish",
  "item.minecraft.glowstone_dust": "Glowstone Dust",
  "item.minecraft.goat_horn": "Goat Horn",
  "item.minecraft.goat_spawn_egg": "Adder Stone o' Goat",
  "item.minecraft.gold_ingot": "Gold Ingot",
  "item.minecraft.gold_nugget": "Gold Lump",
  "item.minecraft.golden_apple": "Gilded Apple",
  "item.minecraft.golden_axe": "Golden Axe",
  "item.minecraft.golden_boots": "Golden Sabatons",
  "item.minecraft.golden_carrot": "Golden Caret",
  "item.minecraft.golden_chestplate": "Golden Breast Plate",
  "item.minecraft.golden_helmet": "Golden Casque",
  "item.minecraft.golden_hoe": "Golden Hoe",
  "item.minecraft.golden_horse_armor": "Gilded Horse Barding",
  "item.minecraft.golden_leggings": "Golden Greaves",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armour",
  "item.minecraft.golden_pickaxe": "Golden Pickaxe",
  "item.minecraft.golden_shovel": "Golden Spade",
  "item.minecraft.golden_spear": "Golden Lance",
  "item.minecraft.golden_sword": "Golden Sword",
  "item.minecraft.gray_bundle": "Grey Fardel",
  "item.minecraft.gray_dye": "Grey Dye",
  "item.minecraft.gray_harness": "Grey Harness",
  "item.minecraft.green_bundle": "Green Fardel",
  "item.minecraft.green_dye": "Green Dye",
  "item.minecraft.green_harness": "Green Harness",
  "item.minecraft.guardian_spawn_egg": "Adder Stone o' Water Sprite",
  "item.minecraft.gunpowder": "Gunpowder",
  "item.minecraft.guster_banner_pattern": "Banner Pattern",
  "item.minecraft.guster_banner_pattern.desc": "Gust",
  "item.minecraft.guster_banner_pattern.new": "A Breeze-Inspired Pattern Upon the Banner's Field",
  "item.minecraft.guster_pottery_sherd": "Gust Potsherd",
  "item.minecraft.happy_ghast_spawn_egg": "Adder Stone o' Merry Ghast",
  "item.minecraft.harness": "Harness",
  "item.minecraft.heart_of_the_sea": "Neptune's Heart",
  "item.minecraft.heart_pottery_shard": "Heart Potshard",
  "item.minecraft.heart_pottery_sherd": "Heart Potsherd",
  "item.minecraft.heartbreak_pottery_shard": "Heartbreak Potshard",
  "item.minecraft.heartbreak_pottery_sherd": "Heartbreak Potsherd",
  "item.minecraft.hoglin_spawn_egg": "Adder Stone o' Hoglin",
  "item.minecraft.honey_bottle": "Honey Bottle",
  "item.minecraft.honeycomb": "Honeycomb",
  "item.minecraft.hopper_minecart": "Conveyer in a Cart",
  "item.minecraft.horse_spawn_egg": "Adder Stone o' Horse",
  "item.minecraft.host_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.host_armor_trim_smithing_template.new": "Host Armour Trim",
  "item.minecraft.howl_pottery_shard": "Howl Potshard",
  "item.minecraft.howl_pottery_sherd": "Howl Potsherd",
  "item.minecraft.husk_spawn_egg": "Adder Stone o' Fear Gortach",
  "item.minecraft.ink_sac": "Ink Sack",
  "item.minecraft.iron_axe": "Iron Axe",
  "item.minecraft.iron_boots": "Iron Sabatons",
  "item.minecraft.iron_chestplate": "Iron Breast Plate",
  "item.minecraft.iron_golem_spawn_egg": "Atter Stone o' Iron Homunculus",
  "item.minecraft.iron_helmet": "Iron Casque",
  "item.minecraft.iron_hoe": "Iron Hoe",
  "item.minecraft.iron_horse_armor": "Iron Horse Barding",
  "item.minecraft.iron_ingot": "Iron Ingot",
  "item.minecraft.iron_leggings": "Iron Greaves",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armour",
  "item.minecraft.iron_nugget": "Iron Lump",
  "item.minecraft.iron_pickaxe": "Iron Pickaxe",
  "item.minecraft.iron_shovel": "Iron Spade",
  "item.minecraft.iron_spear": "Iron Lance",
  "item.minecraft.iron_sword": "Iron Sword",
  "item.minecraft.item_frame": "Item Frame",
  "item.minecraft.jungle_boat": "Exotic Boat",
  "item.minecraft.jungle_chest_boat": "Chest in an Exotic Boat",
  "item.minecraft.knowledge_book": "Book o' Knowledge",
  "item.minecraft.lapis_lazuli": "Lapis",
  "item.minecraft.lava_bucket": "Bucket of Molten Stone",
  "item.minecraft.lead": "Tether",
  "item.minecraft.leather": "Leather",
  "item.minecraft.leather_boots": "Leathern Boots",
  "item.minecraft.leather_chestplate": "Leathern Doublet",
  "item.minecraft.leather_helmet": "Leathern Coif",
  "item.minecraft.leather_horse_armor": "Leathern Horse Barding",
  "item.minecraft.leather_leggings": "Leathern Hose",
  "item.minecraft.light_blue_bundle": "Whey Fardel",
  "item.minecraft.light_blue_dye": "Whey Dye",
  "item.minecraft.light_blue_harness": "Whey Harness",
  "item.minecraft.light_gray_bundle": "Pale Grey Fardel",
  "item.minecraft.light_gray_dye": "Pale Grey Dye",
  "item.minecraft.light_gray_harness": "Pale Grey Harness",
  "item.minecraft.lime_bundle": "Lincoln Fardel",
  "item.minecraft.lime_dye": "Lincoln Dye",
  "item.minecraft.lime_harness": "Lincoln Harness",
  "item.minecraft.lingering_potion": "Lingering Potion",
  "item.minecraft.lingering_potion.effect.awkward": "Awkward Lingering Potion",
  "item.minecraft.lingering_potion.effect.empty": "Uncraftable Lingering Potion",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Lingering Potion o' Incombustion",
  "item.minecraft.lingering_potion.effect.harming": "Lingering Potion o' Debilitation",
  "item.minecraft.lingering_potion.effect.healing": "Lingering Potion o' Physic",
  "item.minecraft.lingering_potion.effect.infested": "Lingering Potion o' Infestation",
  "item.minecraft.lingering_potion.effect.invisibility": "Lingering Potion o' Invisibility",
  "item.minecraft.lingering_potion.effect.leaping": "Lingering Potion o' Lightness",
  "item.minecraft.lingering_potion.effect.levitation": "Lingering Potion o' Floating",
  "item.minecraft.lingering_potion.effect.luck": "Lingering Potion o' Fortune",
  "item.minecraft.lingering_potion.effect.mundane": "Mundane Lingering Potion",
  "item.minecraft.lingering_potion.effect.night_vision": "Lingering Potion o' Arrant Vision",
  "item.minecraft.lingering_potion.effect.oozing": "Lingering Potion o' Slimefilling",
  "item.minecraft.lingering_potion.effect.poison": "Lingering Potion o' Plague",
  "item.minecraft.lingering_potion.effect.regeneration": "Lingering Potion o' Restorative",
  "item.minecraft.lingering_potion.effect.slow_falling": "Lingering Potion o' Ground's Forbearance",
  "item.minecraft.lingering_potion.effect.slowness": "Lingering Potion o' Tarrying",
  "item.minecraft.lingering_potion.effect.strength": "Lingering Potion o' Power",
  "item.minecraft.lingering_potion.effect.swiftness": "Lingering Potion o' Hieing",
  "item.minecraft.lingering_potion.effect.thick": "Thick Lingering Potion",
  "item.minecraft.lingering_potion.effect.turtle_master": "Lingering Potion o' Shield Wall",
  "item.minecraft.lingering_potion.effect.water": "Lingering Water Bottle",
  "item.minecraft.lingering_potion.effect.water_breathing": "Lingering Potion o' Water Breathing",
  "item.minecraft.lingering_potion.effect.weakness": "Lingering Potion o' Ague",
  "item.minecraft.lingering_potion.effect.weaving": "Lingering Potion o' Weaving",
  "item.minecraft.lingering_potion.effect.wind_charged": "Lingering Potion o' Tempests",
  "item.minecraft.llama_spawn_egg": "Adder Stone o' Llama",
  "item.minecraft.lodestone_compass": "Lodestone Compass",
  "item.minecraft.mace": "Mace",
  "item.minecraft.magenta_bundle": "Mulberry Fardel",
  "item.minecraft.magenta_dye": "Mulberry Dye",
  "item.minecraft.magenta_harness": "Mulberry Harness",
  "item.minecraft.magma_cream": "Brimstone Cream",
  "item.minecraft.magma_cube_spawn_egg": "Adder Stone o' Burning Cube",
  "item.minecraft.mangrove_boat": "Marsh Boat",
  "item.minecraft.mangrove_chest_boat": "Chest in a Marsh Boat",
  "item.minecraft.map": "Blank Map",
  "item.minecraft.melon_seeds": "Melon Seeds",
  "item.minecraft.melon_slice": "Melon Piece",
  "item.minecraft.milk_bucket": "Bucket o' Milk",
  "item.minecraft.minecart": "Iron Cart",
  "item.minecraft.miner_pottery_shard": "Miner Potshard",
  "item.minecraft.miner_pottery_sherd": "Miner Potsherd",
  "item.minecraft.mojang_banner_pattern": "Mojang Banner Pattern",
  "item.minecraft.mojang_banner_pattern.desc": "Thing",
  "item.minecraft.mojang_banner_pattern.new": "The Banner Pattern of the Thing, Emblazoned with Enchanted Apple’s Mark",
  "item.minecraft.mooshroom_spawn_egg": "Adder Stone o' Mooshroom",
  "item.minecraft.mourner_pottery_shard": "Mourner Potshard",
  "item.minecraft.mourner_pottery_sherd": "Mourner Potsherd",
  "item.minecraft.mule_spawn_egg": "Adder Stone o' Mule",
  "item.minecraft.mushroom_stew": "Mushroom Stew",
  "item.minecraft.music_disc_11": "Music Plate",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Music Plate",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Music Plate",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Music Plate",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Music Plate",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Music Plate",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Music Plate",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Music Plate",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Music Plate",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Music Plate",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Music Plate",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Music Plate",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Music Plate",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Music Plate",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Music Plate",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Music Plate",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Music Plate",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Music Plate",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Music Plate",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Music Plate",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Music Plate",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Raw Mutton",
  "item.minecraft.name_tag": "Name Marker",
  "item.minecraft.nautilus_shell": "Nautilus Shell",
  "item.minecraft.nautilus_spawn_egg": "Adder Stone o' Nautilus",
  "item.minecraft.nether_brick": "Nether Brick",
  "item.minecraft.nether_star": "Nether Star",
  "item.minecraft.nether_wart": "Nether Wart",
  "item.minecraft.netherite_axe": "Netherite Axe",
  "item.minecraft.netherite_boots": "Netherite Sabatons",
  "item.minecraft.netherite_chestplate": "Netherite Breastplate",
  "item.minecraft.netherite_helmet": "Netherite Helmet",
  "item.minecraft.netherite_hoe": "Netherite Hoe",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Barding",
  "item.minecraft.netherite_ingot": "Netherite Ingot",
  "item.minecraft.netherite_leggings": "Netherite Greaves",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armour",
  "item.minecraft.netherite_pickaxe": "Netherite Pickaxe",
  "item.minecraft.netherite_scrap": "Scrap of Netherite",
  "item.minecraft.netherite_shovel": "Netherite Shovel",
  "item.minecraft.netherite_spear": "Netherite Lance",
  "item.minecraft.netherite_sword": "Netherite Sword",
  "item.minecraft.netherite_upgrade_smithing_template": "Smithing Template",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Imbuement of the Metal of the Fire",
  "item.minecraft.oak_boat": "Oaken Boat",
  "item.minecraft.oak_chest_boat": "Chest in an Oaken Boat",
  "item.minecraft.ocelot_spawn_egg": "Adder Stone o' Wildcat",
  "item.minecraft.ominous_bottle": "Portentful Bottle",
  "item.minecraft.ominous_trial_key": "Gothic Key of Trial",
  "item.minecraft.orange_bundle": "Tawny Fardel",
  "item.minecraft.orange_dye": "Tawny Dye",
  "item.minecraft.orange_harness": "Tawny Harness",
  "item.minecraft.painting": "Painting",
  "item.minecraft.pale_oak_boat": "Pallor Boat",
  "item.minecraft.pale_oak_chest_boat": "Chest in a Pallor Boat",
  "item.minecraft.panda_spawn_egg": "Adder Stone o' Parti-Coloured Bear",
  "item.minecraft.paper": "Paper",
  "item.minecraft.parched_spawn_egg": "Adder Stone o' Sere",
  "item.minecraft.parrot_spawn_egg": "Adder Stone o' Parrot",
  "item.minecraft.phantom_membrane": "Night Hag's Skin",
  "item.minecraft.phantom_spawn_egg": "Adder Stone o' Night Hag",
  "item.minecraft.pig_spawn_egg": "Adder Stone o' Pig",
  "item.minecraft.piglin_banner_pattern": "Banner Pattern",
  "item.minecraft.piglin_banner_pattern.desc": "Snout",
  "item.minecraft.piglin_banner_pattern.new": "The Banner Pattern Bearing the Proud Snout’s Mark",
  "item.minecraft.piglin_brute_spawn_egg": "Adder Stone o' Piglin Brute",
  "item.minecraft.piglin_spawn_egg": "Adder Stone o' Piglin",
  "item.minecraft.pillager_spawn_egg": "Adder Stone o' Wild Huntsman",
  "item.minecraft.pink_bundle": "Carnation Fardel",
  "item.minecraft.pink_dye": "Carnation Dye",
  "item.minecraft.pink_harness": "Carnation Harness",
  "item.minecraft.pitcher_plant": "Pitch'r Planteth",
  "item.minecraft.pitcher_pod": "Pitch'r Pod",
  "item.minecraft.plenty_pottery_shard": "Plenty Potshard",
  "item.minecraft.plenty_pottery_sherd": "Plenty Potsherd",
  "item.minecraft.poisonous_potato": "Green Potato",
  "item.minecraft.polar_bear_spawn_egg": "Adder Stone o' Bear",
  "item.minecraft.popped_chorus_fruit": "Popp'd Chorus Fruit",
  "item.minecraft.porkchop": "Raw Bacon",
  "item.minecraft.potato": "Potato",
  "item.minecraft.potion": "Potion",
  "item.minecraft.potion.effect.awkward": "Awkward Potion",
  "item.minecraft.potion.effect.empty": "Uncraftable Potion",
  "item.minecraft.potion.effect.fire_resistance": "Potion o' Incombustion",
  "item.minecraft.potion.effect.harming": "Potion o' Debilitation",
  "item.minecraft.potion.effect.healing": "Potion o' Physic",
  "item.minecraft.potion.effect.infested": "Arrow o' Infestation",
  "item.minecraft.potion.effect.invisibility": "Potion o' Invisibility",
  "item.minecraft.potion.effect.leaping": "Potion o' Lightness",
  "item.minecraft.potion.effect.levitation": "Potion o' Floating",
  "item.minecraft.potion.effect.luck": "Potion o' Fortune",
  "item.minecraft.potion.effect.mundane": "Mundane Potion",
  "item.minecraft.potion.effect.night_vision": "Potion o' Arrant Vision",
  "item.minecraft.potion.effect.oozing": "Potion o' Slimefilling",
  "item.minecraft.potion.effect.poison": "Potion o' Plague",
  "item.minecraft.potion.effect.regeneration": "Potion o' Restorative",
  "item.minecraft.potion.effect.slow_falling": "Potion o' Ground's Forbearance",
  "item.minecraft.potion.effect.slowness": "Potion o' Tarrying",
  "item.minecraft.potion.effect.strength": "Potion o' Power",
  "item.minecraft.potion.effect.swiftness": "Potion o' Hieing",
  "item.minecraft.potion.effect.thick": "Thick Potion",
  "item.minecraft.potion.effect.turtle_master": "Potion o' Shield Wall",
  "item.minecraft.potion.effect.water": "Water Bottle",
  "item.minecraft.potion.effect.water_breathing": "Potion o' Water Breathing",
  "item.minecraft.potion.effect.weakness": "Potion o' Ague",
  "item.minecraft.potion.effect.weaving": "Potion o' Weaving",
  "item.minecraft.potion.effect.wind_charged": "Potion o' Tempests",
  "item.minecraft.pottery_shard_archer": "Archer Potshard",
  "item.minecraft.pottery_shard_arms_up": "Up In Arms Potshard",
  "item.minecraft.pottery_shard_prize": "Prize Potshard",
  "item.minecraft.pottery_shard_skull": "Death's-mazzard pottery shard",
  "item.minecraft.powder_snow_bucket": "Bucket of Powdered Snow",
  "item.minecraft.prismarine_crystals": "Prismarine Crystals",
  "item.minecraft.prismarine_shard": "Prismarine Shard",
  "item.minecraft.prize_pottery_shard": "Prize Potshard",
  "item.minecraft.prize_pottery_sherd": "Prize Potsherd",
  "item.minecraft.pufferfish": "Blowfish",
  "item.minecraft.pufferfish_bucket": "Blowfish in a Bucket",
  "item.minecraft.pufferfish_spawn_egg": "Adder Stone o' Blowfish",
  "item.minecraft.pumpkin_pie": "Pumpion Pie",
  "item.minecraft.pumpkin_seeds": "Pumpion Seeds",
  "item.minecraft.purple_bundle": "Purple Fardel",
  "item.minecraft.purple_dye": "Purple Dye",
  "item.minecraft.purple_harness": "Purple Harness",
  "item.minecraft.quartz": "Nether Quarz",
  "item.minecraft.rabbit": "Raw Hare",
  "item.minecraft.rabbit_foot": "Hare's Foot",
  "item.minecraft.rabbit_hide": "Hare Skin",
  "item.minecraft.rabbit_spawn_egg": "Adder Stone o' Hare",
  "item.minecraft.rabbit_stew": "Hare Stew",
  "item.minecraft.raiser_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Rais'r Armour Trim",
  "item.minecraft.ravager_spawn_egg": "Adder Stone o' Wild Hound",
  "item.minecraft.raw_copper": "Raw Copp'r",
  "item.minecraft.raw_gold": "Raw Gold",
  "item.minecraft.raw_iron": "Raw Iron",
  "item.minecraft.recovery_compass": "Recovery Compass",
  "item.minecraft.red_bundle": "Red Fardel",
  "item.minecraft.red_dye": "Red Dye",
  "item.minecraft.red_harness": "Red Harness",
  "item.minecraft.redstone": "Redstone Dust",
  "item.minecraft.resin_brick": "Hardened Sap Brick",
  "item.minecraft.resin_clump": "Hardened Sap",
  "item.minecraft.rib_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rib Armour Trim",
  "item.minecraft.rotten_flesh": "Rotten Flesh",
  "item.minecraft.saddle": "Saddle",
  "item.minecraft.salmon": "Raw Salmon",
  "item.minecraft.salmon_bucket": "Salmon in a Bucket",
  "item.minecraft.salmon_spawn_egg": "Adder Stone o' Salmon",
  "item.minecraft.scrape_pottery_sherd": "Scrape Potsherd",
  "item.minecraft.scute": "Scale",
  "item.minecraft.sentry_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Sentry Armour Trim",
  "item.minecraft.shaper_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Shap'r Armour Trim",
  "item.minecraft.sheaf_pottery_shard": "Sheaf Potshard",
  "item.minecraft.sheaf_pottery_sherd": "Sheaf Potsherd",
  "item.minecraft.shears": "Shears",
  "item.minecraft.sheep_spawn_egg": "Adder Stone o' Sheep",
  "item.minecraft.shelter_pottery_shard": "Shelter Potshard",
  "item.minecraft.shelter_pottery_sherd": "Shelter Potsherd",
  "item.minecraft.shield": "Shield",
  "item.minecraft.shield.black": "Black Shield",
  "item.minecraft.shield.blue": "Blue Shield",
  "item.minecraft.shield.brown": "Brown Shield",
  "item.minecraft.shield.cyan": "Turquoise Shield",
  "item.minecraft.shield.gray": "Grey Shield",
  "item.minecraft.shield.green": "Green Shield",
  "item.minecraft.shield.light_blue": "Whey Shield",
  "item.minecraft.shield.light_gray": "Pale Grey Shield",
  "item.minecraft.shield.lime": "Lincoln Shield",
  "item.minecraft.shield.magenta": "Mulberry Shield",
  "item.minecraft.shield.orange": "Tawny Shield",
  "item.minecraft.shield.pink": "Carnation Shield",
  "item.minecraft.shield.purple": "Purple Shield",
  "item.minecraft.shield.red": "Red Shield",
  "item.minecraft.shield.white": "White Shield",
  "item.minecraft.shield.yellow": "Yellow Shield",
  "item.minecraft.shulker_shell": "Shulker Shell",
  "item.minecraft.shulker_spawn_egg": "Adder Stone o' Shulker",
  "item.minecraft.sign": "Sign",
  "item.minecraft.silence_armor_trim_smithing_template": "Forging Template",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Silence Armour Trim",
  "item.minecraft.silverfish_spawn_egg": "Adder Stone o' Atomy",
  "item.minecraft.skeleton_horse_spawn_egg": "Adder Stone o' Ghostly Horse",
  "item.minecraft.skeleton_spawn_egg": "Adder Stone o' Restless Skeleton",
  "item.minecraft.skull_banner_pattern": "Skull Banner Pattern",
  "item.minecraft.skull_banner_pattern.desc": "Poor Yorick's Charge",
  "item.minecraft.skull_banner_pattern.new": "A Banner Embattled with the Grim Skull’s Charge",
  "item.minecraft.skull_pottery_shard": "Death's-mazzard pottery shard",
  "item.minecraft.skull_pottery_sherd": "Skull Potsherd",
  "item.minecraft.slime_ball": "Slimeball",
  "item.minecraft.slime_spawn_egg": "Adder Stone o' Slime Cube",
  "item.minecraft.smithing_template": "Mending",
  "item.minecraft.smithing_template.applies_to": "Applies to:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Addeth ingot or crystal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armour",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Addeth a piece of armour",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Minerals & Gemstones",
  "item.minecraft.smithing_template.ingredients": "Components:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Addeth Netherite Ingot",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Mending",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Addeth diamond armour, weapon, or implement",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netherite Ingot",
  "item.minecraft.smithing_template.upgrade": "Reform: ",
  "item.minecraft.sniffer_spawn_egg": "Adder Stone o' Sniffener",
  "item.minecraft.snort_pottery_shard": "Snort Potshard",
  "item.minecraft.snort_pottery_sherd": "Snort Potsherd",
  "item.minecraft.snout_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snout Armour Trim",
  "item.minecraft.snow_golem_spawn_egg": "Atter Stone o' Snow Homunculus",
  "item.minecraft.snowball": "Snowball",
  "item.minecraft.spectral_arrow": "Ghostly Arrow",
  "item.minecraft.spider_eye": "Spider Eye",
  "item.minecraft.spider_spawn_egg": "Adder Stone o' Spider",
  "item.minecraft.spire_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spire Armour Trim",
  "item.minecraft.splash_potion": "Throwing Potion",
  "item.minecraft.splash_potion.effect.awkward": "Awkward Throwing Potion",
  "item.minecraft.splash_potion.effect.empty": "Uncraftable Throwing Potion",
  "item.minecraft.splash_potion.effect.fire_resistance": "Throwing Potion o’ Incombustion",
  "item.minecraft.splash_potion.effect.harming": "Throwing Potion o’ Debilitation",
  "item.minecraft.splash_potion.effect.healing": "Throwing Potion o’ Physic",
  "item.minecraft.splash_potion.effect.infested": "Throwing Potion o’ Infestation",
  "item.minecraft.splash_potion.effect.invisibility": "Throwing Potion o’ Invisibility",
  "item.minecraft.splash_potion.effect.leaping": "Throwing Potion o’ Lightness",
  "item.minecraft.splash_potion.effect.levitation": "Throwing Potion o’ Floating",
  "item.minecraft.splash_potion.effect.luck": "Throwing Potion o’ Fortune",
  "item.minecraft.splash_potion.effect.mundane": "Mundane Throwing Potion",
  "item.minecraft.splash_potion.effect.night_vision": "Throwing Potion o’ Arrant Vision",
  "item.minecraft.splash_potion.effect.oozing": "Throwing Potion o’ Slimefilling",
  "item.minecraft.splash_potion.effect.poison": "Throwing Potion o’ Plague",
  "item.minecraft.splash_potion.effect.regeneration": "Throwing Potion o’ Restorative",
  "item.minecraft.splash_potion.effect.slow_falling": "Throwing Potion o’ Ground's Forbearance",
  "item.minecraft.splash_potion.effect.slowness": "Throwing Potion o’ Tarrying",
  "item.minecraft.splash_potion.effect.strength": "Throwing Potion o’ Power",
  "item.minecraft.splash_potion.effect.swiftness": "Throwing Potion o’ Hieing",
  "item.minecraft.splash_potion.effect.thick": "Thick Throwing Potion",
  "item.minecraft.splash_potion.effect.turtle_master": "Throwing Potion o’ Shield Wall",
  "item.minecraft.splash_potion.effect.water": "Throwing Potion o’ Water",
  "item.minecraft.splash_potion.effect.water_breathing": "Throwing Potion o’ Water Breathinig",
  "item.minecraft.splash_potion.effect.weakness": "Throwing Potion o’ Ague",
  "item.minecraft.splash_potion.effect.weaving": "Throwing Potion o’ Weaving",
  "item.minecraft.splash_potion.effect.wind_charged": "Throwing Potion o’ Tempests",
  "item.minecraft.spruce_boat": "Pine Boat",
  "item.minecraft.spruce_chest_boat": "Chest in a Pine Boat",
  "item.minecraft.spyglass": "Spying-glass",
  "item.minecraft.squid_spawn_egg": "Adder Stone o' Cuttlefish",
  "item.minecraft.stick": "Stick",
  "item.minecraft.stone_axe": "Stone Axe",
  "item.minecraft.stone_hoe": "Stone Hoe",
  "item.minecraft.stone_pickaxe": "Stone Pickaxe",
  "item.minecraft.stone_shovel": "Stone Spade",
  "item.minecraft.stone_spear": "Stone Lance",
  "item.minecraft.stone_sword": "Stone Sword",
  "item.minecraft.stray_spawn_egg": "Adder Stone o' Mummy",
  "item.minecraft.strider_spawn_egg": "Adder Stone o' Strider",
  "item.minecraft.string": "String",
  "item.minecraft.sugar": "Sugar",
  "item.minecraft.suspicious_stew": "Suspicious Stew",
  "item.minecraft.sweet_berries": "Sweet Berries",
  "item.minecraft.tadpole_bucket": "Todpole in a Bucket",
  "item.minecraft.tadpole_spawn_egg": "Adder Stone o' Todpole",
  "item.minecraft.tide_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Tide Armour Trim",
  "item.minecraft.tipped_arrow": "Steeped Arrow",
  "item.minecraft.tipped_arrow.effect.awkward": "Steeped Arrow",
  "item.minecraft.tipped_arrow.effect.empty": "Uncraftable Steeped Arrow",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Arrow o' Incombustion",
  "item.minecraft.tipped_arrow.effect.harming": "Arrow o' Debilitation",
  "item.minecraft.tipped_arrow.effect.healing": "Arrow o' Physic",
  "item.minecraft.tipped_arrow.effect.infested": "Arrow o' Infestation",
  "item.minecraft.tipped_arrow.effect.invisibility": "Arrow o' Invisibility",
  "item.minecraft.tipped_arrow.effect.leaping": "Arrow o' Lightness",
  "item.minecraft.tipped_arrow.effect.levitation": "Arrow o' Floating",
  "item.minecraft.tipped_arrow.effect.luck": "Arrow o' Fortune",
  "item.minecraft.tipped_arrow.effect.mundane": "Steeped Arrow",
  "item.minecraft.tipped_arrow.effect.night_vision": "Arrow o' Arrant Vision",
  "item.minecraft.tipped_arrow.effect.oozing": "Arrow o' Slimefilling",
  "item.minecraft.tipped_arrow.effect.poison": "Arrow o' Plague",
  "item.minecraft.tipped_arrow.effect.regeneration": "Arrow o' Restorative",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Arrow o' Ground's Forbearance",
  "item.minecraft.tipped_arrow.effect.slowness": "Arrow o' Tarrying",
  "item.minecraft.tipped_arrow.effect.strength": "Arrow o' Power",
  "item.minecraft.tipped_arrow.effect.swiftness": "Arrow o' Hieing",
  "item.minecraft.tipped_arrow.effect.thick": "Taynted Arewe",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Arrow o' Shield Wall",
  "item.minecraft.tipped_arrow.effect.water": "Plashing Arrow",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Arrow o' Water Breathing",
  "item.minecraft.tipped_arrow.effect.weakness": "Arrow o' Weakness",
  "item.minecraft.tipped_arrow.effect.weaving": "Arrow o' Weaving",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Arrow o' Tempests",
  "item.minecraft.tnt_minecart": "Gunpowder Cask in a Cart",
  "item.minecraft.torchflower_seeds": "Lampplant Seeds",
  "item.minecraft.totem_of_undying": "Periapt",
  "item.minecraft.trader_llama_spawn_egg": "Adder Stone o' Pack Llama",
  "item.minecraft.trial_key": "Trial Key",
  "item.minecraft.trident": "Trident",
  "item.minecraft.tropical_fish": "Exotic Fish",
  "item.minecraft.tropical_fish_bucket": "Exotic Fish in a Bucket",
  "item.minecraft.tropical_fish_spawn_egg": "Adder Stone o' Exotic Fish",
  "item.minecraft.turtle_helmet": "Turtle Shell",
  "item.minecraft.turtle_scute": "Turtle Scale",
  "item.minecraft.turtle_spawn_egg": "Adder Stone o' Turtle",
  "item.minecraft.vex_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Vex Armour Trim",
  "item.minecraft.vex_spawn_egg": "Adder Stone o' Familiar",
  "item.minecraft.villager_spawn_egg": "Adder Stone o' Peasant",
  "item.minecraft.vindicator_spawn_egg": "Adder Stone o' Boggart",
  "item.minecraft.wandering_trader_spawn_egg": "Adder Stone o' Wandering Merchant",
  "item.minecraft.ward_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ward Armour Trim",
  "item.minecraft.warden_spawn_egg": "Adder Stone o' Warden",
  "item.minecraft.warped_fungus_on_a_stick": "Warp'd Mushrump on a Stick",
  "item.minecraft.water_bucket": "Water'd Bucket",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wayfind'r Armour Trim",
  "item.minecraft.wheat": "Wheat",
  "item.minecraft.wheat_seeds": "Wheat Seeds",
  "item.minecraft.white_bundle": "White Fardel",
  "item.minecraft.white_dye": "White Dye",
  "item.minecraft.white_harness": "White Harness",
  "item.minecraft.wild_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wild Armour Trim",
  "item.minecraft.wind_charge": "Tempest",
  "item.minecraft.witch_spawn_egg": "Adder Stone o' Witch",
  "item.minecraft.wither_skeleton_spawn_egg": "Adder Stone o' Wither'd Skeleton",
  "item.minecraft.wither_spawn_egg": "Adder Stone o' Wither",
  "item.minecraft.wolf_armor": "Wolf Armour",
  "item.minecraft.wolf_spawn_egg": "Adder Stone o' Wolf",
  "item.minecraft.wooden_axe": "Wooden Axe",
  "item.minecraft.wooden_hoe": "Wooden Hoe",
  "item.minecraft.wooden_pickaxe": "Wooden Pickaxe",
  "item.minecraft.wooden_shovel": "Wooden Spade",
  "item.minecraft.wooden_spear": "Wooden Lance",
  "item.minecraft.wooden_sword": "Wooden Sword",
  "item.minecraft.writable_book": "Book and Quill",
  "item.minecraft.written_book": "Writ Book",
  "item.minecraft.yellow_bundle": "Yellow Fardel",
  "item.minecraft.yellow_dye": "Yellow Dye",
  "item.minecraft.yellow_harness": "Yellow Harness",
  "item.minecraft.zoglin_spawn_egg": "Adder Stone o' Zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Adder Stone o' Undead Horse",
  "item.minecraft.zombie_nautilus_spawn_egg": "Adder Stone o' Undead Nautilus",
  "item.minecraft.zombie_spawn_egg": "Adder Stone o' Undead Wight",
  "item.minecraft.zombie_villager_spawn_egg": "Adder Stone o' Cannibal Peasant",
  "item.minecraft.zombified_piglin_spawn_egg": "Adder Stone o' Rott'd Piglin"
}
export const enws = items; 
